// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:34:05.903Z
// Property: Portofino (ID: 6767906449166547)
// Collections: 29 amenities, 6 floorplans (live), 53 photos, 69 POIs, 5 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449166547",
  "property_external_id": "436776",
  "property_zillow_url": "https://www.zillow.com/apartments/wichita-ks/portofino/65dKfG/",
  "property_apartments_url": null,
  "property_google_business_url": "https://www.google.com/maps/place/Portofino+Apartments/data=!4m2!3m1!1s0x0:0x8b4da59346a71588?sa=X&ved=2ahUKEwj7sJ6ahL2SAxXBrpUCHUoJDEcQ_BJ6BAgPEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "15147453852",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "portofino",
  "property_name": "Portofino",
  "property_website_url": "https://www.caseusa.com/apartments/ks/wichita/portofino/",
  "property_domain": null,
  "property_address": "12526 East Central Avenue",
  "property_full_address": "12526 E Central Ave, Wichita, KS 67206, USA",
  "property_address_1": "12526 East Central Avenue",
  "property_address_2": null,
  "property_address_city": "Wichita",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "67206",
  "property_address_country": "US",
  "property_address_county": "Sedgwick County",
  "property_neighborhood_address": null,
  "property_address_latitude": "37.6952",
  "property_address_longitude": "-97.1918",
  "property_email": "portofino@caseusa.com",
  "property_phone": "(316) 323-1549",
  "property_call_tracking_phone": "833-707-2146",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Portofino in Wichita, KS, enjoy the perfect blend of comfort and convenience. Our spacious one- and two-bedroom apartments feature modern kitchens, large walk-in closets, and private patios. Amenities like a resort-style pool, 24-hour fitness center, and bark park create a vibrant community. Find your new home today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "**Welcome to Portofino – Your Perfect Apartment Oasis in Wichita, KS!**\n\nDiscover the exquisite living experience at Portofino, where comfort meets style in our thoughtfully designed one and two-bedroom floor plans. Located conveniently near K96 and I35, our community offers easy access to everything Wichita has to offer. Each apartment features spacious living areas, custom cabinetry, and fully equipped kitchens with stainless steel appliances, creating an inviting atmosphere that you'll love coming home to.\n\nAt Portofino, residents enjoy a wide range of exceptional amenities that cater to your lifestyle. Spend leisurely afternoons at our sparkling swimming pool with a sundeck or gather with friends at the grill and chill area with a cozy fireplace. For pet lovers, our bark park provides a safe, fun environment for your furry friends to play. Our clubhouse and business center offer great spaces for work and relaxation, while the 24-hour fitness center ensures you can maintain your active lifestyle anytime.\n\nYour comfort and convenience are prioritized with features such as limited access gates, 24-hour emergency maintenance, and online rental payments. Additionally, select apartments come with inviting patios or balconies, fireplaces, and extra storage options, while garages and short-term lease options are also available to suit your needs.\n\nWith perks like super-fast internet powered by AT&T and spacious walk-in closets, Portofino is designed for your enjoyment. \n\nFind your new home today—browse our availability or schedule a tour to visit our vibrant community! Embrace the lifestyle you’ve always wanted at Portofino.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019dbbe9-0dde-74e7-bca7-322c32315f08.webp",
  "property_featured_image_media": {
    "alt_text": "Portofino community building with arched entrance, Spanish tile roof, and tower with property logo.",
    "public_id": "019dbbe9-0dde-74e7-bca7-322c32315f08",
    "storage_key": "property/6767906449166547/019dbbe9-0dde-74e7-bca7-322c32315f08.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Dogs and cats allowed. Maximum of two pets per unit. No weight limit.",
  "property_pet_policy_description": "We allow a maximum of two pets per unit (cats and dogs). There is no weight limit. Pet rent is $30 per pet per month. A one‑time, non‑refundable pet fee equal to one‑half of one month’s rent per pet is required.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://portofinoapartmentswichita.securecafe.com/onlineleasing/portofino-2/floorplans.aspx",
  "property_resident_portal_url": "https://portofinoapartmentswichita.securecafe.com/residentservices/portofino-2/userlogin.aspx",
  "property_apply_now_url": "https://portofinoapartmentswichita.securecafe.com/onlineleasing/portofino-2/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-1afe-706b-a897-d302f11c5707.webp",
  "property_primary_logo_media": {
    "alt_text": "Portofino Apartments logo",
    "public_id": "019cfb4f-1afe-706b-a897-d302f11c5707",
    "storage_key": "property/6767906449166547/019cfb4f-1afe-706b-a897-d302f11c5707.webp",
    "width": 360,
    "height": 96
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-abef-7601-a3dc-ed3d3e3e74a5.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Portofino Apartments logo",
    "public_id": "019cfb4f-abef-7601-a3dc-ed3d3e3e74a5",
    "storage_key": "property/6767906449166547/019cfb4f-abef-7601-a3dc-ed3d3e3e74a5.webp",
    "width": 360,
    "height": 96
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-b3e0-745e-9f55-84861ea9ddea.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Portofino Apartments logo",
    "public_id": "019cfb4f-b3e0-745e-9f55-84861ea9ddea",
    "storage_key": "property/6767906449166547/019cfb4f-b3e0-745e-9f55-84861ea9ddea.webp",
    "width": 360,
    "height": 96
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#16618e",
  "property_secondary_color": "#000000",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1176",
  "property_sqft_min": "789",
  "property_sqft_max": "1176",
  "property_price_range": "1149 - 1629",
  "property_price_min": "1149",
  "property_price_max": "1629",
  "property_available_units": 16,
  "property_facebook_url": "https://www.facebook.com/PortofinoAptsWichita/mentions/",
  "property_instagram_url": "https://www.instagram.com/p/DRxK8VlETuQ/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ4aRKuhf8uocRiBWnRpOlTYs",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/portofino-apartments-wichita-2",
  "property_tiktok_url": "https://www.tiktok.com/@portofinowichita",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Portofino",
  "property_home_romance_title": "Embrace Comfort and Connection in Your Dream Apartment Community",
  "property_home_amenities_blurb": "Welcome to Portofino in Wichita, KS, where upscale living meets unmatched convenience. Choose from our thoughtfully designed one and two-bedroom floor plans, featuring spacious interiors and modern finishes. Unwind in our grill and chill area, take a dip in the pool, or stay active in our 24-hour fitness center—your perfect lifestyle awaits!",
  "property_home_floorplans_blurb": "Welcome to Portofino in Wichita, KS, where comfort meets style. Choose from our thoughtfully designed one and two-bedroom apartments, each crafted for modern living. Embrace vibrant community life and scenic surroundings. Browse our available apartment homes today to find the floor plan that perfectly suits your lifestyle.",
  "property_home_gallery_blurb": "Welcome to Portofino in Wichita, KS, where modern living meets comfort. Choose from spacious one- and two-bedroom floor plans, complete with stunning amenities like a sparkling pool, bark park, and a grill area with a fireplace. Picture yourself living here, with effortless access to I35 and K96!",
  "property_home_neighborhood_blurb": "At Portofino in Wichita, KS, vibrant living awaits where modern one- and two-bedroom apartments meet a dynamic neighborhood. Nestled near fascinating attractions like the Kansas Aviation Museum and the iconic Frank Lloyd Wright's Allen House, your new home is steps away from adventure. Surround yourself with culture, nature, and community.",
  "property_home_reviews_blurb": "Welcome to Portofino, where community shines through the kindness of our exceptional staff. Our residents rave, \"Jade is one of the kindest people I have ever met,\" creating a warm, family-like atmosphere. With spacious apartments and a dedicated team, you’ll feel right at home in Wichita's serene neighborhood! ",
  "property_neighborhood_blurb": "At Portofino in Wichita, KS, vibrant living meets endless exploration. Nestled near the Kansas Aviation Museum, Woolsey Hall, and Cessna Stadium, our community offers an ideal blend of comfort and convenience. Unwind at Edgemoor Park or discover nearby educational hubs like Wichita State University. Experience the best of local culture and activities!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Portofino in Wichita, KS, where modern comfort meets convenience. With one and two-bedroom floor plans, our community features a stunning swimming pool, a vibrant grill and chill area, and a bark park for your furry friends. Experience spacious living, a 24-hour fitness center, and more—your perfect home awaits!",
  "property_applynow_blurb": "At Portofino in Wichita, KS, experience modern living with spacious one and two-bedroom floor plans, stylish amenities, and convenience at your fingertips. Enjoy our 24-hour fitness center, relaxing poolside sundeck, and a vibrant clubhouse. Embrace unparalleled comfort and connectivity—your new home awaits, ready to lease online today!",
  "property_contactus_blurb": "At Portofino in Wichita, KS, your perfect home awaits with stylish one and two-bedroom floor plans tailored for every lifestyle. Experience modern living, vibrant community spaces, and a welcoming atmosphere. Have questions? Contact our leasing team today to learn how to make Portofino your new home sweet home!",
  "property_faqs_blurb": "At Portofino in Wichita, KS, find the perfect match for your lifestyle with our thoughtfully designed one and two-bedroom floor plans. Have questions? Our FAQs page is your go-to resource for insights into our community, amenities, and more. Uncover the details that make Portofino your ideal home!",
  "property_floorplans_blurb": "At Portofino in Wichita, KS, your ideal living space awaits. Choose from our stylish one-bedroom or spacious two-bedroom floor plans that cater to your lifestyle. With thoughtful designs and modern amenities, these apartments are crafted for comfort. Browse our available homes and find the perfect fit for you.",
  "property_gallery_blurb": "At Portofino in Wichita, KS, picture vibrant living with spacious one and two-bedroom apartments featuring modern amenities like a sparkling pool, a grill and chill area, and a fun bark park. Enjoy convenience with quick access to major highways and lightning-fast internet. Your perfect home awaits!",
  "property_interactivemap_blurb": "Welcome to Portofino in Wichita, KS, where spacious living meets modern comfort. With one and two-bedroom floor plans and a stunning array of amenities, including a vibrant Grill and Chill area, Bark Park, and a refreshing swimming pool, your new home awaits. Use our interactive community map to find your perfect fit!",
  "property_pets_blurb": "At Portofino in Wichita, KS, your furry friends are part of the family! With no weight limits and a cozy atmosphere, you can comfortably enjoy life with up to two pets. Relish the freedom to explore nearby parks while making unforgettable memories together in your new home.",
  "property_referafriend_blurb": "At Portofino in Wichita, KS, thoughtful design meets modern comfort with spacious one and two-bedroom floor plans. Share the joy of our vibrant community—refer a friend today! Great friends make great neighbors, and together, you can create lasting memories in your new home. Join us at Portofino!",
  "property_residentaccess_blurb": "Welcome to your sanctuary at Portofino in Wichita, KS. Access your resident portal for seamless rent payments, hassle-free maintenance scheduling, and personalized services. Whether you’re in a cozy one-bedroom or spacious two-bedroom, your perfect living experience awaits. Login now and embrace a lifestyle designed just for you!",
  "property_reviews_blurb": "At Portofino in Wichita, KS, our residents rave about the exceptional community atmosphere and dedicated staff. “They truly care about the community and do anything to make you feel as happy as possible!” Experience the spacious apartments and welcoming environment that make Portofino a cherished home.",
  "property_created_at": "1759851199706",
  "property_scheduletour_blurb": "At Portofino in Wichita, KS, our thoughtfully designed one and two-bedroom apartments cater to your lifestyle. Each floor plan enhances comfort and convenience, perfect for creating your ideal home. Want to hear firsthand experiences? Schedule a tour and see what our residents love about living in our vibrant community!",
  "property_thankyou_blurb": "Thank you for your interest in Portofino, where stylish one and two-bedroom floor plans await you in the heart of Wichita, KS. Expect a member of our team to connect with you soon, ready to help you find your ideal home in our vibrant community. Stay tuned!",
  "property_virtualtours_blurb": "Welcome to Portofino in Wichita, KS, where comfort meets style. Our thoughtfully designed one and two-bedroom floor plans offer the perfect backdrop for your next chapter. Take a virtual tour today and envision your new life in our welcoming community—your ideal home awaits!",
  "property_copyright": "2025 All Rights Reserved. Portofino",
  "property_seo_title_home": "Portofino |  Apartments in Wichita, KS",
  "property_seo_description_home": "Welcome to Portofino in Wichita, KS! Experience stylish living with top-notch amenities, spacious floor plans, and a thriving community. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Wichita, KS Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at Portofino in Wichita, KS. Choose from stylish one- and two-bedroom floor plans that fit your unique lifestyle perfectly!",
  "property_seo_title_amenities": "Amenities | Wichita, KS Apartments for Rent",
  "property_seo_description_amenities": "Discover luxury at Portofino in Wichita, KS, featuring a pool, fitness center, and pet-friendly spaces for your ideal lifestyle!",
  "property_seo_title_gallery": "Gallery | Apartments in Wichita, KS",
  "property_seo_description_gallery": "Experience vibrant living at Portofino in Wichita, KS! Enjoy spacious floor plans, a relaxing pool, and top-notch amenities. Picture your new life today!",
  "property_seo_title_virtualtours": "Virtual Tours | Portofino Apartments",
  "property_seo_description_virtualtours": "Experience Portofino in Wichita, KS! Take a virtual tour of stylish one and two-bedroom apartments, and see your future home come to life today!",
  "property_seo_title_interactivemap": "Interactive Map | Portofino Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Portofino in Wichita, KS! Use our interactive map to explore spacious one and two-bedroom apartments with top-tier amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Wichita, KS",
  "property_seo_description_neighborhood": "Uncover the charm of Portofino in Wichita, KS. Explore local favorites, vibrant neighborhoods, and hidden gems just steps from your new home.",
  "property_seo_title_contact": "Contact Us | Portofino",
  "property_seo_description_contact": "Connect with the Portofino team in Wichita, KS. From one- to two-bedroom plans, we’re here to help with your apartment journey. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Wichita, KS",
  "property_seo_description_faqs": "Uncover answers to your top questions at Portofino in Wichita, KS. Learn about our spacious apartments, amenities, and flexible leasing options. Start now!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Wichita, KS",
  "property_seo_description_reviews": "Discover why residents at Portofino in Wichita, KS love our amenities, spacious layouts, and vibrant community. Call us home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Wichita, KS",
  "property_seo_description_applynow": "Unwind at Portofino in Wichita! Enjoy spacious layouts, modern amenities, and a fitness center. Lease your dream apartment online now!",
  "property_seo_title_residentaccess": "Resident Access | Portofino",
  "property_seo_description_residentaccess": "Log in to your Portofino resident portal for easy rent payments, maintenance requests, and community updates—your key to worry-free living in Wichita!",
  "property_seo_title_referafriend": "Refer A Friend | Portofino",
  "property_seo_description_referafriend": "Refer a friend to Portofino in Wichita, KS! Great friends create great neighbors, and a welcoming community awaits. Share the love today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Portofino",
  "property_seo_description_scheduletour": "Experience the charm of Portofino in Wichita, KS. Schedule your tour today and find your perfect apartment home in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Portofino",
  "property_seo_description_privacy": "At Portofino in Wichita, KS, your privacy matters. Dive into our policy to see how we protect your information while you enjoy your home. View now!",
  "property_seo_title_accessibility": "Website Accessibility | Portofino",
  "property_seo_description_accessibility": "Join us at Portofino in Wichita, KS, where inclusivity thrives and everyone feels at home. Experience comfort for all today!",
  "property_seo_title_sitemap": "Sitemap | Portofino",
  "property_seo_description_sitemap": "Navigate your way through Portofino in Wichita, KS. Check out our sitemap to find your perfect apartment and uncover all our community has to offer!",
  "property_seo_title_thankyou": "Thank You | Portofino",
  "property_seo_description_thankyou": "Thank you for reaching out to Portofino in Wichita, KS! Our team is eager to assist you in finding your perfect apartment home. Stay tuned for quick updates!",
  "property_seo_title_pets": "Pet Policy | Apartments in Wichita, KS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865624676",
  "amenities": [
    {
      "id": "ec_beb208dfb691a6e700f1d9a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127396977",
      "title": "Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1aa88a6373721fa554480bd9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127396978",
      "title": "Close to K96 and I35",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_23747b7e5b859dadc8505507",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127396979",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_19f3cb3a419c944981989127",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127396980",
      "title": "Grill and Chill Area with Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc14a186b6a05c31e606c0cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127396981",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76d8838ec2308758584c883c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127396982",
      "title": "Limited Access Gates",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ae273dab03c0a2e6fabaae20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127396983",
      "title": "24Hour Fitness Center with Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_80c2070e4c363fbe11550c3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127396984",
      "title": "24Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f9579ed0cc52b5a673d1a5e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127396985",
      "title": "Onsite Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c8f632c4aa8bd5cab7a9fe46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127396986",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_19f5b869862b67deab2035e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127396987",
      "title": "Swimming Pool with Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f7cedb615a85d2fe9a53cf1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127396988",
      "title": "Short Term Lease",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d977d5a8a3663bf179dd9efa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127396989",
      "title": "Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9223b34aa340c819ef7b9619",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127396990",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be7239e1997893fe37e85fcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127396991",
      "title": "Online Rental Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_23e81516338486d43a5dc353",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "128042515",
      "title": "AT&T",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a4d6d99cbf16a60965e7db93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127398457",
      "title": "Get Connected To Super Fast Internet Powered by AT&T",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0f8a3cc66dfd1f048911fdbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127398458",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_074ec0b39bdb19daca594ba0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127398459",
      "title": "Extra Storage Space in Select Units",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d96990a64fcc6037642d93e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127398460",
      "title": "Fireplace in Select Units",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f87f646616fd89bdb0a22a80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127398461",
      "title": "Patio or Balcony in Select Units",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_43241688f49d8398bcb4d32c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127398462",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a6b183a1bb9ee8e97edbf3f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127398463",
      "title": "Washer and Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a0169b389b8e0ddacdfd9024",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127398464",
      "title": "Ceramic Tile in Kitchen and Baths",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e9d2d7526fa1d59b0e3dc065",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127398465",
      "title": "Loft Style Living Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_85c2ede72676e1bcd60a8410",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127398466",
      "title": "Fully Equipped Kitchen with Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ac5fe0ac0e767563268fc30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127398467",
      "title": "Spacious Living Areas",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed483446623e39731e7b6ec8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127398468",
      "title": "Custom Cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d7a443eac46402b16ebbeb8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "yardi",
      "external_id": "127398469",
      "title": "Large Walk in Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_bbf2754d-5c3b-4af4-8b1c-5298d5e5d17a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-0da4-7041-8be2-88d8e410e2cf.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, toilet, and bathtub with shower curtain.",
        "public_id": "019d20b6-0da4-7041-8be2-88d8e410e2cf",
        "storage_key": "property/6767906449166547/019d20b6-0da4-7041-8be2-88d8e410e2cf.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Stylish bathroom featuring a modern vanity, toilet, and a bathtub with an attractive shower curtain.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304022%20(1).JPG"
    },
    {
      "id": "custom_2d9812ce-e122-4708-a2be-37a436b2f55f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-1b63-75ad-889a-878db8dbeb01.webp",
      "image_media": {
        "alt_text": "A kitchen with a white refrigerator and wooden cabinets.",
        "public_id": "019d20b6-1b63-75ad-889a-878db8dbeb01",
        "storage_key": "property/6767906449166547/019d20b6-1b63-75ad-889a-878db8dbeb01.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring wood cabinets, a microwave, refrigerator, stove, dishwasher, and a granite countertop island with seating.",
      "link": "",
      "alt_text": "A kitchen with a white refrigerator and wooden cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7303717%20(1).JPG"
    },
    {
      "id": "custom_3023343d-dbe8-4d5a-8d2d-a3a9c8a30ebc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019dbbe8-fd51-702c-bbf4-3cbce6486c30.webp",
      "image_media": {
        "alt_text": "A swimming pool surrounded by blue lounge chairs and apartment buildings.",
        "public_id": "019dbbe8-fd51-702c-bbf4-3cbce6486c30",
        "storage_key": "property/6767906449166547/019dbbe8-fd51-702c-bbf4-3cbce6486c30.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling resort-style swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Enjoy the perfect amenity for sunny days.",
      "link": "",
      "alt_text": "A swimming pool surrounded by blue lounge chairs and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7303676%20(1).JPG"
    },
    {
      "id": "custom_8721daf1-82fe-4652-9b55-8ac3683bba53",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-34e2-7187-a691-c2c972b46bd0.webp",
      "image_media": {
        "alt_text": "A round table with four stools and a vase of branches on it, with a desk and chair in the background.",
        "public_id": "019d20b6-34e2-7187-a691-c2c972b46bd0",
        "storage_key": "property/6767906449166547/019d20b6-34e2-7187-a691-c2c972b46bd0.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A cozy corner features a round table with stools, perfect for a quick meal or conversation, and a dedicated workspace with a desk and chair.",
      "link": "",
      "alt_text": "A round table with four stools and a vase of branches on it, with a desk and chair in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304097%20(1).JPG"
    },
    {
      "id": "custom_57bd7b47-ad3c-4707-9d1d-f262e6425211",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-4541-77b7-aed0-a4a84c33b8d4.webp",
      "image_media": {
        "alt_text": "Bedroom with a large wooden bed, nightstand, and window.",
        "public_id": "019d20b6-4541-77b7-aed0-a4a84c33b8d4",
        "storage_key": "property/6767906449166547/019d20b6-4541-77b7-aed0-a4a84c33b8d4.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-sized bed with storage, a nightstand with a lamp, and a large window with blinds and decorative curtains.",
      "link": "",
      "alt_text": "Bedroom with a large wooden bed, nightstand, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304037%20(1).JPG"
    },
    {
      "id": "custom_d0886bd8-23b3-44b0-9c09-16a179c0bd0d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-5adf-7339-a1c0-f8d5a425022e.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and a tunnel.",
        "public_id": "019d20b6-5adf-7339-a1c0-f8d5a425022e",
        "storage_key": "property/6767906449166547/019d20b6-5adf-7339-a1c0-f8d5a425022e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with agility equipment and a fun tunnel for your furry friends to play in.",
      "link": "",
      "alt_text": "Dog park with agility equipment and a tunnel.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/Portofino%20Bark%20Park.JPG"
    },
    {
      "id": "custom_b5ef7fc0-c9f6-4453-be9c-7cb706b59c85",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-5b83-7783-8df4-f056f42b67d7.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and dining area.",
        "public_id": "019d20b6-5b83-7783-8df4-f056f42b67d7",
        "storage_key": "property/6767906449166547/019d20b6-5b83-7783-8df4-f056f42b67d7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sectional sofa, a stylish coffee table, and a dedicated dining area. Perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Living room with a sectional sofa, coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7303702%20(1).JPG"
    },
    {
      "id": "custom_a3009fe8-5209-4f0c-bbed-b7a7502eb54e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-654f-719b-834f-fa9bd268bfc8.webp",
      "image_media": {
        "alt_text": "Modern kitchen with wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019d20b6-654f-719b-834f-fa9bd268bfc8",
        "storage_key": "property/6767906449166547/019d20b6-654f-719b-834f-fa9bd268bfc8.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring ample wood cabinetry, sleek granite countertops, and a full suite of stainless steel appliances, perfect for preparing meals.",
      "link": "",
      "alt_text": "Modern kitchen with wood cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7303837%20(1).JPG"
    },
    {
      "id": "custom_45cad8cd-0934-4aee-809a-edf7ed48d505",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-6ae2-740a-82b0-3591be84b740.webp",
      "image_media": {
        "alt_text": "A modern bathroom with a wooden vanity and white fixtures.",
        "public_id": "019d20b6-6ae2-740a-82b0-3591be84b740",
        "storage_key": "property/6767906449166547/019d20b6-6ae2-740a-82b0-3591be84b740.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy a spacious bathroom featuring a modern wood vanity with granite countertops, a large mirror, and a shower-bathtub combo.",
      "link": "",
      "alt_text": "A modern bathroom with a wooden vanity and white fixtures.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304142%20(1).JPG"
    },
    {
      "id": "custom_a5aa7592-50f4-4894-a82b-0e7961bd30de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-6cb5-75c2-afd0-ade918dd17f8.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, and TV, leading into a bedroom.",
        "public_id": "019d20b6-6cb5-75c2-afd0-ade918dd17f8",
        "storage_key": "property/6767906449166547/019d20b6-6cb5-75c2-afd0-ade918dd17f8.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living area seamlessly connected to a comfortable bedroom, perfect for relaxation and modern living.",
      "link": "",
      "alt_text": "Living room with a sofa, coffee table, and TV, leading into a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7303942%20(1).JPG"
    },
    {
      "id": "custom_ba702c47-ecf3-48cd-ac52-bec85a7467ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-7131-726b-a11a-0e4d3668b731.webp",
      "image_media": {
        "alt_text": "Living room and open kitchen area with bar seating.",
        "public_id": "019d20b6-7131-726b-a11a-0e4d3668b731",
        "storage_key": "property/6767906449166547/019d20b6-7131-726b-a11a-0e4d3668b731.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living area with a modern aesthetic, open to a fully equipped kitchen with bar seating. Perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and open kitchen area with bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7303927%20(1).JPG"
    },
    {
      "id": "custom_a7d5452e-cbd4-4c5b-9466-d9c1ad808c11",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-75ec-77bc-97d2-7ebd425d77ac.webp",
      "image_media": {
        "alt_text": "Outdoor patio with wooden pergola, comfortable seating, and stone accent walls.",
        "public_id": "019d20b6-75ec-77bc-97d2-7ebd425d77ac",
        "storage_key": "property/6767906449166547/019d20b6-75ec-77bc-97d2-7ebd425d77ac.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind on our inviting outdoor patio, complete with a shaded pergola and plush seating, perfect for enjoying the fresh air.",
      "link": "",
      "alt_text": "Outdoor patio with wooden pergola, comfortable seating, and stone accent walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7303561%20(1).JPG"
    },
    {
      "id": "custom_bd188c1f-1c71-4125-97f1-2fd1daa10083",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-7b0a-713a-a99e-418bc7879a5f.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, sofa, coffee table, and dining area.",
        "public_id": "019d20b6-7b0a-713a-a99e-418bc7879a5f",
        "storage_key": "property/6767906449166547/019d20b6-7b0a-713a-a99e-418bc7879a5f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable sofa, and a stylish dining area, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a fireplace, sofa, coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304092%20(1).JPG"
    },
    {
      "id": "custom_75581234-d7ec-42df-bf54-8a5a7e1b1713",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-7a40-735b-a099-8bd37bc89439.webp",
      "image_media": {
        "alt_text": "A dining room with a table and chairs.",
        "public_id": "019d20b6-7a40-735b-a099-8bd37bc89439",
        "storage_key": "property/6767906449166547/019d20b6-7a40-735b-a099-8bd37bc89439.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Elegant dining area featuring a polished wooden table set for four, complemented by a striking piece of wall art and chic upholstered chairs. Opens to a patio or balcony space.",
      "link": "",
      "alt_text": "A dining room with a table and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7303967%20(1).JPG"
    },
    {
      "id": "custom_1a3bfe22-0d8b-4b2c-8872-33076e421d25",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-8ad2-778b-9895-58192b1a78b9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019d20b6-8ad2-778b-9895-58192b1a78b9",
        "storage_key": "property/6767906449166547/019d20b6-8ad2-778b-9895-58192b1a78b9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this spacious kitchen, featuring a full suite of stainless steel appliances, ample cabinet space, and a large island perfect for meal prep.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7303962%20(1).JPG"
    },
    {
      "id": "custom_b226a127-56d1-4f5b-86d5-3200d83ba00f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-93dd-70e7-84d2-8c4384236a0f.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, shower, vanity, and cabinet.",
        "public_id": "019d20b6-93dd-70e7-84d2-8c4384236a0f",
        "storage_key": "property/6767906449166547/019d20b6-93dd-70e7-84d2-8c4384236a0f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A clean and spacious bathroom featuring a bathtub, toilet, and wooden vanity with a granite countertop.",
      "link": "",
      "alt_text": "Bathroom with toilet, shower, vanity, and cabinet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7303877%20(1).JPG"
    },
    {
      "id": "custom_cd57cef9-eba5-40a8-bf01-69478a9e5c08",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-9c79-7239-b2d0-a9d2018f4322.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wood cabinets.",
        "public_id": "019d20b6-9c79-7239-b2d0-a9d2018f4322",
        "storage_key": "property/6767906449166547/019d20b6-9c79-7239-b2d0-a9d2018f4322.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304072%20(1).JPG"
    },
    {
      "id": "custom_1f7010f6-0483-40ae-be7d-17c5419b3f03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-9ee2-71a2-a009-7ca371731e7f.webp",
      "image_media": {
        "alt_text": "A living room with a fireplace, grey couch, and a coffee table.",
        "public_id": "019d20b6-9ee2-71a2-a009-7ca371731e7f",
        "storage_key": "property/6767906449166547/019d20b6-9ee2-71a2-a009-7ca371731e7f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, entertainment center with TV, and a coffee table, perfect for relaxing.",
      "link": "",
      "alt_text": "A living room with a fireplace, grey couch, and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304062%20(1).JPG"
    },
    {
      "id": "custom_a0aaedda-faaa-42f4-9a14-938d8652be92",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-a379-71af-bd82-104ecb4b6eb4.webp",
      "image_media": {
        "alt_text": "Bathroom with wooden vanity, white toilet, and shower with patterned curtain.",
        "public_id": "019d20b6-a379-71af-bd82-104ecb4b6eb4",
        "storage_key": "property/6767906449166547/019d20b6-a379-71af-bd82-104ecb4b6eb4.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a spacious vanity with ample storage, a white toilet, and a bathtub with a decorative shower curtain.",
      "link": "",
      "alt_text": "Bathroom with wooden vanity, white toilet, and shower with patterned curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7303907%20(1).JPG"
    },
    {
      "id": "custom_37f8b006-9ea6-45cd-8dfd-0cc061b5ea2e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019dbbe8-fdd3-738e-8fb9-2f3efa9e6aaa.webp",
      "image_media": {
        "alt_text": "Interior common area with seating, fireplace, and ornate chandeliers.",
        "public_id": "019dbbe8-fdd3-738e-8fb9-2f3efa9e6aaa",
        "storage_key": "property/6767906449166547/019dbbe8-fdd3-738e-8fb9-2f3efa9e6aaa.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed common areas, featuring comfortable seating, elegant chandeliers, and a warm, inviting atmosphere.",
      "link": "",
      "alt_text": "Interior common area with seating, fireplace, and ornate chandeliers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7303582%20(1).JPG"
    },
    {
      "id": "custom_2ee50e5c-1d51-4373-b3a9-87c9cec49676",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-acfc-729f-89a5-ef01f1a5f42e.webp",
      "image_media": {
        "alt_text": "A living room with a couch, coffee table, and bar stools.",
        "public_id": "019d20b6-acfc-729f-89a5-ef01f1a5f42e",
        "storage_key": "property/6767906449166547/019d20b6-acfc-729f-89a5-ef01f1a5f42e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living room and open-concept kitchen area, perfect for entertaining. Features a comfortable sofa, modern coffee table, and a breakfast bar with stools.",
      "link": "",
      "alt_text": "A living room with a couch, coffee table, and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7303797%20(1).JPG"
    },
    {
      "id": "custom_19a87a3c-b2f3-4590-9ed7-94c8e6d854d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-b5bc-70fb-8ea6-0c7b727148dd.webp",
      "image_media": {
        "alt_text": "Dining area with a table and chairs, and a home office desk setup with a stool.",
        "public_id": "019d20b6-b5bc-70fb-8ea6-0c7b727148dd",
        "storage_key": "property/6767906449166547/019d20b6-b5bc-70fb-8ea6-0c7b727148dd.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy versatile living spaces with a dedicated dining area and a convenient home office setup, perfect for work or study.",
      "link": "",
      "alt_text": "Dining area with a table and chairs, and a home office desk setup with a stool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7303822%20(1).JPG"
    },
    {
      "id": "custom_7f81d6e8-3777-4ca7-ab67-9c2e49a9fa5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-bc4f-712b-a652-0eed551a4525.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and window.",
        "public_id": "019d20b6-bc4f-712b-a652-0eed551a4525",
        "storage_key": "property/6767906449166547/019d20b6-bc4f-712b-a652-0eed551a4525.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished bedroom featuring a comfortable queen-size bed, a stylish nightstand with a lamp, and a large window with pleasant views.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304117%20(1).JPG"
    },
    {
      "id": "custom_03895dbe-b2aa-4e94-8ddc-717693dda4c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-c097-74ad-bb49-825c453b0a69.webp",
      "image_media": {
        "alt_text": "A bedroom with a bed, nightstand, and a ceiling fan.",
        "public_id": "019d20b6-c097-74ad-bb49-825c453b0a69",
        "storage_key": "property/6767906449166547/019d20b6-c097-74ad-bb49-825c453b0a69.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a king-size bed with a patterned comforter, a wooden nightstand with a lamp, and a plush armchair by the window.",
      "link": "",
      "alt_text": "A bedroom with a bed, nightstand, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7303757%20(1).JPG"
    },
    {
      "id": "custom_d9e955f9-cf53-40fb-9b9d-7443123dd3c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-c4c9-769d-bc1a-69e9c8ac1921.webp",
      "image_media": {
        "alt_text": "A bedroom with a bed, nightstand, and a ceiling fan.",
        "public_id": "019d20b6-c4c9-769d-bc1a-69e9c8ac1921",
        "storage_key": "property/6767906449166547/019d20b6-c4c9-769d-bc1a-69e9c8ac1921.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in this spacious bedroom, featuring a comfortable king-size bed, elegant nightstands, and a cooling ceiling fan. Ample closet space keeps your room tidy.",
      "link": "",
      "alt_text": "A bedroom with a bed, nightstand, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7303882%20(1).JPG"
    },
    {
      "id": "custom_d61c51bf-f66c-4953-8787-23140fcc257f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-d3ef-7042-9e96-67df5ba7f603.webp",
      "image_media": {
        "alt_text": "A cozy bedroom featuring a queen-size bed with a vibrant, abstract-print comforter and colorful accent pillows.",
        "public_id": "019d20b6-d3ef-7042-9e96-67df5ba7f603",
        "storage_key": "property/6767906449166547/019d20b6-d3ef-7042-9e96-67df5ba7f603.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom, complete with a plush tufted headboard and a colorful abstract comforter that adds a pop of personality.",
      "link": "",
      "alt_text": "A cozy bedroom featuring a queen-size bed with a vibrant, abstract-print comforter and colorful accent pillows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7303857%20(1).JPG"
    },
    {
      "id": "custom_7b0c244f-646a-4ccf-8902-a66ab49a1dcd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-def6-752e-8149-0bf4f413e9c2.webp",
      "image_media": {
        "alt_text": "Bathroom with wooden vanity, granite countertop, toilet, and bathtub with shower curtain.",
        "public_id": "019d20b6-def6-752e-8149-0bf4f413e9c2",
        "storage_key": "property/6767906449166547/019d20b6-def6-752e-8149-0bf4f413e9c2.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a double vanity with granite countertops, a large mirror, a toilet, and a bathtub with a shower. The space is complemented by wood-toned cabinetry and stylish tile flooring.",
      "link": "",
      "alt_text": "Bathroom with wooden vanity, granite countertop, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7303782%20(1).JPG"
    },
    {
      "id": "custom_06d4911c-c42d-45c7-9ae0-1cdf585445ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-defe-720a-81ac-8fa4d5d85abf.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a king-size bed, nightstands, and ceiling fan.",
        "public_id": "019d20b6-defe-720a-81ac-8fa4d5d85abf",
        "storage_key": "property/6767906449166547/019d20b6-defe-720a-81ac-8fa4d5d85abf.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious primary bedroom featuring a comfortable king-size bed, elegant nightstands with lamps, and a modern ceiling fan for year-round comfort.",
      "link": "",
      "alt_text": "Primary bedroom with a king-size bed, nightstands, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7303992%20(1).JPG"
    },
    {
      "id": "custom_48fb1c9b-fbde-4459-9bcb-9fa6bdc3891e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-e490-7643-b515-0b3e44f87a49.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances, granite countertops, and wood cabinets.",
        "public_id": "019d20b6-e490-7643-b515-0b3e44f87a49",
        "storage_key": "property/6767906449166547/019d20b6-e490-7643-b515-0b3e44f87a49.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space. Perfect for home chefs and entertaining.",
      "link": "",
      "alt_text": "Kitchen with stainless steel appliances, granite countertops, and wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7303732%20(1).JPG"
    },
    {
      "id": "custom_ac4612a8-0524-46ee-9bf0-faf259571fe9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-eda3-7609-b0a5-494396bfe5f8.webp",
      "image_media": {
        "alt_text": "A kitchen with a marble countertop and white appliances.",
        "public_id": "019d20b6-eda3-7609-b0a5-494396bfe5f8",
        "storage_key": "property/6767906449166547/019d20b6-eda3-7609-b0a5-494396bfe5f8.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this beautifully appointed kitchen, featuring ample cabinet space, granite countertops, and a convenient breakfast bar.",
      "link": "",
      "alt_text": "A kitchen with a marble countertop and white appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7303947%20(1).JPG"
    },
    {
      "id": "custom_5a2b70f3-7bdb-4ca6-950a-33b00e8ca3bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d20b6-f280-764c-b671-11d0ffbc1719.webp",
      "image_media": {
        "alt_text": "A bathroom with a toilet, sink, and wooden cabinets.",
        "public_id": "019d20b6-f280-764c-b671-11d0ffbc1719",
        "storage_key": "property/6767906449166547/019d20b6-f280-764c-b671-11d0ffbc1719.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A beautifully appointed bathroom featuring a spacious wooden vanity, a modern toilet, and a clean bathtub with a decorative shower curtain.",
      "link": "",
      "alt_text": "A bathroom with a toilet, sink, and wooden cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304017%20(1).JPG"
    },
    {
      "id": "custom_9e49258d-7462-4132-aa92-8ac7c6bbfe5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cc-5105-73ba-a763-7224684f1441.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, an elliptical, a recumbent bike, weight machines, and free weights.",
        "public_id": "019db0cc-5105-73ba-a763-7224684f1441",
        "storage_key": "property/6767906449166547/019db0cc-5105-73ba-a763-7224684f1441.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our fully-equipped fitness center, featuring cardio machines, strength training equipment, and free weights for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, an elliptical, a recumbent bike, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2d29324b-15fc-446f-8114-900d567b2600",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cc-5166-7068-80e3-df77867e5a58.webp",
      "image_media": {
        "alt_text": "A fenced-in dog park with agility equipment, including ramps, a tunnel, and weave poles.",
        "public_id": "019db0cc-5166-7068-80e3-df77867e5a58",
        "storage_key": "property/6767906449166547/019db0cc-5166-7068-80e3-df77867e5a58.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Our community dog park provides a safe and fun space for your furry friends to play and exercise with various agility obstacles.",
      "link": "",
      "alt_text": "A fenced-in dog park with agility equipment, including ramps, a tunnel, and weave poles.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b2b12ba2-21cd-448d-ba46-831e54a571f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cc-4f39-73dc-a5a8-e49e22427b21.webp",
      "image_media": {
        "alt_text": "Sidewalk winding through a grassy courtyard with apartment buildings on either side.",
        "public_id": "019db0cc-4f39-73dc-a5a8-e49e22427b21",
        "storage_key": "property/6767906449166547/019db0cc-4f39-73dc-a5a8-e49e22427b21.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Beautifully maintained grounds and a scenic walkway connect residents to their homes in this charming apartment community.",
      "link": "",
      "alt_text": "Sidewalk winding through a grassy courtyard with apartment buildings on either side.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_390ce9a2-a16c-4d76-a29c-c600ebe0f1f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cc-4966-70e9-b085-26c5aadf9e18.webp",
      "image_media": {
        "alt_text": "Apartment complex exterior with manicured lawns and walkways.",
        "public_id": "019db0cc-4966-70e9-b085-26c5aadf9e18",
        "storage_key": "property/6767906449166547/019db0cc-4966-70e9-b085-26c5aadf9e18.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully maintained grounds of an apartment community, featuring lush green lawns, clean walkways, and attractive building exteriors.",
      "link": "",
      "alt_text": "Apartment complex exterior with manicured lawns and walkways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5e49cd35-bc22-49fd-b2ab-c763a83b6610",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cc-55d5-7508-8c36-502bb68a4594.webp",
      "image_media": {
        "alt_text": "Portofino apartment complex community building with a tower and entrance.",
        "public_id": "019db0cc-55d5-7508-8c36-502bb68a4594",
        "storage_key": "property/6767906449166547/019db0cc-55d5-7508-8c36-502bb68a4594.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Portofino apartments, a beautiful community with stunning architecture and lush landscaping.",
      "link": "",
      "alt_text": "Portofino apartment complex community building with a tower and entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_26d75109-69cb-4d93-8d68-91b9ca766aa5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cc-4f74-71bf-a91c-13c186892459.webp",
      "image_media": {
        "alt_text": "Dog park with benches, agility equipment, and a red tunnel.",
        "public_id": "019db0cc-4f74-71bf-a91c-13c186892459",
        "storage_key": "property/6767906449166547/019db0cc-4f74-71bf-a91c-13c186892459.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, perfect for your furry friends to play and socialize in a safe, fenced environment. Features include agility obstacles and seating for owners.",
      "link": "",
      "alt_text": "Dog park with benches, agility equipment, and a red tunnel.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1703641d-ef93-407b-9b4c-d933d9d70e84",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cc-31af-727b-a697-6c5c1213b976.webp",
      "image_media": {
        "alt_text": "A fenced-in dog park area with agility equipment like a tunnel and a seesaw, with apartment buildings in the background.",
        "public_id": "019db0cc-31af-727b-a697-6c5c1213b976",
        "storage_key": "property/6767906449166547/019db0cc-31af-727b-a697-6c5c1213b976.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, complete with fun agility equipment for your furry friends to play on. Located conveniently near the apartment buildings.",
      "link": "",
      "alt_text": "A fenced-in dog park area with agility equipment like a tunnel and a seesaw, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3ba11aaf-9aa9-4ec0-a7c7-b4fc232c7198",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cc-3282-744c-9b74-a3dd0678fe79.webp",
      "image_media": {
        "alt_text": "Spacious community lounge area with comfortable seating, decorative ceiling beams, and large arched windows.",
        "public_id": "019db0cc-3282-744c-9b74-a3dd0678fe79",
        "storage_key": "property/6767906449166547/019db0cc-3282-744c-9b74-a3dd0678fe79.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed community lounge, featuring plush seating, elegant chandeliers, and ample natural light.",
      "link": "",
      "alt_text": "Spacious community lounge area with comfortable seating, decorative ceiling beams, and large arched windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8daa282a-d31f-44b7-bba5-93521cbfca4b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cc-2203-7239-aacc-6238155c3a2b.webp",
      "image_media": {
        "alt_text": "Business center with computers and desks.",
        "public_id": "019db0cc-2203-7239-aacc-6238155c3a2b",
        "storage_key": "property/6767906449166547/019db0cc-2203-7239-aacc-6238155c3a2b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay connected and productive in our fully equipped business center, featuring computers and high-speed internet.",
      "link": "",
      "alt_text": "Business center with computers and desks.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_72fbd5e6-68df-47e8-8683-6f6324dffec0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cc-1e30-72ba-8c0f-10b0eeeebc7f.webp",
      "image_media": {
        "alt_text": "Modern fitness center with treadmills, an elliptical, weight rack, and exercise balls.",
        "public_id": "019db0cc-1e30-72ba-8c0f-10b0eeeebc7f",
        "storage_key": "property/6767906449166547/019db0cc-1e30-72ba-8c0f-10b0eeeebc7f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines, free weights, and space for stretching.",
      "link": "",
      "alt_text": "Modern fitness center with treadmills, an elliptical, weight rack, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c04dc4f8-ff1c-4022-b70d-fbdc8892763e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cc-091e-752b-9c2e-707e2e423bd6.webp",
      "image_media": {
        "alt_text": "Outdoor courtyard with modern sculpture, seating areas, and swimming pool.",
        "public_id": "019db0cc-091e-752b-9c2e-707e2e423bd6",
        "storage_key": "property/6767906449166547/019db0cc-091e-752b-9c2e-707e2e423bd6.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy the amenities of our community, including this beautifully landscaped courtyard with a modern sculpture and a sparkling swimming pool.",
      "link": "",
      "alt_text": "Outdoor courtyard with modern sculpture, seating areas, and swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_baaa86fd-1cb8-4919-9256-22c97bf6d26c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cc-0faf-75b6-9696-ae312898285a.webp",
      "image_media": {
        "alt_text": "View of the outdoor swimming pool and clubhouse at a multifamily property on a sunny day.",
        "public_id": "019db0cc-0faf-75b6-9696-ae312898285a",
        "storage_key": "property/6767906449166547/019db0cc-0faf-75b6-9696-ae312898285a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, a perfect oasis for residents to enjoy during warm weather. Adjacent to the clubhouse, it offers a refreshing escape.",
      "link": "",
      "alt_text": "View of the outdoor swimming pool and clubhouse at a multifamily property on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7d3d5bfb-7106-4fa1-9d88-e60873857e39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cc-0b02-758f-a280-8a28e9e36909.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with picnic tables, umbrellas, and a built-in grill next to a stone fireplace.",
        "public_id": "019db0cc-0b02-758f-a280-8a28e9e36909",
        "storage_key": "property/6767906449166547/019db0cc-0b02-758f-a280-8a28e9e36909.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor living with comfortable seating, picnic tables, a grill, and a cozy fireplace, perfect for gatherings.",
      "link": "",
      "alt_text": "Outdoor seating area with picnic tables, umbrellas, and a built-in grill next to a stone fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e5bc9d09-228f-4646-be43-5f4793768cc5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cc-2ff1-73cc-b44b-ed4c4a9ac39f.webp",
      "image_media": {
        "alt_text": "Spacious resident lounge with fireplace, seating areas, and dining table.",
        "public_id": "019db0cc-2ff1-73cc-b44b-ed4c4a9ac39f",
        "storage_key": "property/6767906449166547/019db0cc-2ff1-73cc-b44b-ed4c4a9ac39f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our elegant resident lounge, featuring a cozy fireplace, comfortable seating, and a communal dining area perfect for gatherings.",
      "link": "",
      "alt_text": "Spacious resident lounge with fireplace, seating areas, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4bde72e7-46bb-4750-b378-c4c72d6488cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cc-12af-72d0-8745-738ec574e532.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and a decorative sculpture.",
        "public_id": "019db0cc-12af-72d0-8745-738ec574e532",
        "storage_key": "property/6767906449166547/019db0cc-12af-72d0-8745-738ec574e532.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling outdoor swimming pool, surrounded by lush landscaping and comfortable lounge seating.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs and a decorative sculpture.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7ec8795b-e08a-4d40-9803-17f6e75b6692",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cc-105a-72a8-9869-af14ac7b9b0c.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and outdoor seating.",
        "public_id": "019db0cc-105a-72a8-9869-af14ac7b9b0c",
        "storage_key": "property/6767906449166547/019db0cc-105a-72a8-9869-af14ac7b9b0c.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds with seating areas and apartment buildings. Enjoy the outdoors at our community.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with manicured lawns and outdoor seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2738652e-2693-467a-8d87-3e9c341dc176",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cb-f5d0-7240-9ed7-1e8345e3efb1.webp",
      "image_media": {
        "alt_text": "Portofino apartment complex community building with a sign for reserved parking.",
        "public_id": "019db0cb-f5d0-7240-9ed7-1e8345e3efb1",
        "storage_key": "property/6767906449166547/019db0cb-f5d0-7240-9ed7-1e8345e3efb1.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "The community building at Portofino apartments features a beautiful stone facade with arched entrances and a prominent clock tower. Reserved parking is available.",
      "link": "",
      "alt_text": "Portofino apartment complex community building with a sign for reserved parking.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8ad604a2-dc26-4856-9142-4945f73e3a07",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cb-f5ad-755b-99d3-168438595cb7.webp",
      "image_media": {
        "alt_text": "View of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019db0cb-f5ad-755b-99d3-168438595cb7",
        "storage_key": "property/6767906449166547/019db0cb-f5ad-755b-99d3-168438595cb7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool, perfect for relaxing and soaking up the sun. Surrounded by beautiful apartment buildings, it's the ideal spot for leisure.",
      "link": "",
      "alt_text": "View of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_94ab8317-123c-4e11-a723-514804042dad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cb-f5dd-7388-915a-47f776888912.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019db0cb-f5dd-7388-915a-47f776888912",
        "storage_key": "property/6767906449166547/019db0cb-f5dd-7388-915a-47f776888912.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax by the sparkling pool at our community. Perfect for soaking up the sun and unwinding.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_566bb73e-1ede-41c6-8765-04bb282c4c14",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cb-ed22-702d-bb5f-36188b0f1058.webp",
      "image_media": {
        "alt_text": "Spacious communal lounge area with comfortable seating, dining table, and modern decor.",
        "public_id": "019db0cb-ed22-702d-bb5f-36188b0f1058",
        "storage_key": "property/6767906449166547/019db0cb-ed22-702d-bb5f-36188b0f1058.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed communal lounge, featuring plush seating, a large dining table, and stylish decor. Perfect for work or leisure.",
      "link": "",
      "alt_text": "Spacious communal lounge area with comfortable seating, dining table, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_20decc7c-11eb-46bf-841d-12a60343c369",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cb-db14-7178-9059-2db1cbf67c46.webp",
      "image_media": {
        "alt_text": "Outdoor grilling and fireplace area with seating at The Overlook at Overland Park.",
        "public_id": "019db0cb-db14-7178-9059-2db1cbf67c46",
        "storage_key": "property/6767906449166547/019db0cb-db14-7178-9059-2db1cbf67c46.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy outdoor living with built-in grills, a cozy fireplace, and comfortable seating areas at The Overlook at Overland Park.",
      "link": "",
      "alt_text": "Outdoor grilling and fireplace area with seating at The Overlook at Overland Park.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d559720b-ed2d-4c71-a132-2f5b12b6985f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cb-d42b-7272-92a6-3c032b8a2669.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with garages and parking lot.",
        "public_id": "019db0cb-d42b-7272-92a6-3c032b8a2669",
        "storage_key": "property/6767906449166547/019db0cb-d42b-7272-92a6-3c032b8a2669.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings featuring individual garages and a well-maintained parking area.",
      "link": "",
      "alt_text": "Apartment building exterior with garages and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_97cf5379-5803-428f-b934-b2b54b1e906f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2526 N Greenwich Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and fried pickles, and the rolls are a highlight. They highlight the fair prices and fun, casual atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-54eb-76e8-9f9c-a8842714a3dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-54eb-76e8-9f9c-a8842714a3dd",
        "storage_key": "property/6767906449166547/019d270c-54eb-76e8-9f9c-a8842714a3dd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/kansas/wichita-n-greenwich-rd?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=1637772610376225648&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "37.7278459",
      "poi_longitude": "-97.2071071",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-634-1106",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8755-7638-8df1-7ea8957bfa08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8755-7638-8df1-7ea8957bfa08",
        "storage_key": "property/6767906449166547/019d270c-8755-7638-8df1-7ea8957bfa08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_-1abr9uocRcNNWCIOJuhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_c707f2bd-67d9-4de9-8005-de8a8b0ccf70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Topgolf Wichita",
      "poi_type": "Restaurants",
      "poi_address": "2976 N Greenwich Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers fun games and a variety of food and drinks. They also highlight the upbeat atmosphere and friendly staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-542f-778e-b8a5-528f164cedc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-542f-778e-b8a5-528f164cedc9",
        "storage_key": "property/6767906449166547/019d270c-542f-778e-b8a5-528f164cedc9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://topgolf.com/us/wichita/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3659202844621293977&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-wichita",
      "poi_latitude": "37.7368549",
      "poi_longitude": "-97.2071488",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-394-4065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8755-7638-8df1-7ea8957bfa08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8755-7638-8df1-7ea8957bfa08",
        "storage_key": "property/6767906449166547/019d270c-8755-7638-8df1-7ea8957bfa08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGUU5Coj9uocRmUnAkpkZyDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b6e5e5a0-d8bc-462a-9cd2-37a648aaed4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Wichita",
      "poi_type": "Restaurants",
      "poi_address": "1240 N Greenwich Rd, Wichita, KS 67206, USA",
      "poi_short_description": "Family-friendly, game joint known for rotisserie chicken, pickleball courts and yard games.",
      "poi_long_description": "People say this restaurant offers a variety of fun outdoor games, pickleball courts, and a spacious indoor area with TVs and a bar. They also highlight the fun and energetic atmosphere, and the friendly staff.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-559f-7190-8d3f-f7ef125fc529.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-559f-7190-8d3f-f7ef125fc529",
        "storage_key": "property/6767906449166547/019d270c-559f-7190-8d3f-f7ef125fc529.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chickennpickle.com/location/wichita/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3640495953640467354&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chicken-n-pickle---wichita",
      "poi_latitude": "37.70694599999999",
      "poi_longitude": "-97.205714",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-535-7150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8755-7638-8df1-7ea8957bfa08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8755-7638-8df1-7ea8957bfa08",
        "storage_key": "property/6767906449166547/019d270c-8755-7638-8df1-7ea8957bfa08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1ZsOYJL9uocRmqv8GsijhTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_025ca067-91e7-43ea-910c-afab1715c99b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2400 N Greenwich Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves good chicken sandwiches and waffle fries. They also highlight the quick service and friendly staff.\n\nOther reviews mention the drive-thru can be confusing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-53fc-72e8-9e41-76e7ca4fd311.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-53fc-72e8-9e41-76e7ca4fd311",
        "storage_key": "property/6767906449166547/019d270c-53fc-72e8-9e41-76e7ca4fd311.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ks/k96-greenwich-rd-ks?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=4809767043547304648&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "37.726752",
      "poi_longitude": "-97.207335",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-369-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8755-7638-8df1-7ea8957bfa08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8755-7638-8df1-7ea8957bfa08",
        "storage_key": "property/6767906449166547/019d270c-8755-7638-8df1-7ea8957bfa08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJre8SHCP9uocRyJIEk6S5v0I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_2222fa24-a60c-4249-8a27-988220e8e902",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Towne East Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "7700 E Kellogg Dr, Wichita, KS 67207, USA",
      "poi_short_description": "Big mall with a classic range of department stores, specialty boutiques & kiosks, plus a food court.",
      "poi_long_description": "People say this shopping center offers a wide selection of clothes, shoes, and sporting goods, and has a good food court. They also highlight the clean and safe environment, and the fun atmosphere.\n\nOther reviews mention the games can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-5946-766d-aa9c-523cceafd7bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-5946-766d-aa9c-523cceafd7bd",
        "storage_key": "property/6767906449166547/019d270c-5946-766d-aa9c-523cceafd7bd.webp",
        "width": 550,
        "height": 366
      },
      "poi_business_url": "https://www.simon.com/mall/towne-east-square",
      "poi_directions_map_url": "https://maps.google.com/?cid=15194517817475507784&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "towne-east-square",
      "poi_latitude": "37.6832262",
      "poi_longitude": "-97.2469947",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-686-3341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-87b3-72fa-8d31-5823a6488c24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-87b3-72fa-8d31-5823a6488c24",
        "storage_key": "property/6767906449166547/019d270c-87b3-72fa-8d31-5823a6488c24.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZfKSnrz8uocRSKb4c3PF3dI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f043be1f-5945-42e6-b7bb-bbc7612b9863",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1423 N Webb Rd Ste 101, Wichita, KS 67206, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh, organic produce, meat, and prepackaged goods, as well as a bakery, prepared foods, and a coffee shop. They also highlight the clean, organized layout, the friendly and helpful staff, and the convenient Amazon returns.\n\nOther reviews mention the store can be understocked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-5971-779c-b8f0-fcab5e9a19ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-5971-779c-b8f0-fcab5e9a19ae",
        "storage_key": "property/6767906449166547/019d270c-5971-779c-b8f0-fcab5e9a19ae.webp",
        "width": 1280,
        "height": 934
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/wichita?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=11170048129198724117&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "37.7089215",
      "poi_longitude": "-97.227764",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-630-8484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8759-715f-8424-120849d82bc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8759-715f-8424-120849d82bc7",
        "storage_key": "property/6767906449166547/019d270c-8759-715f-8424-120849d82bc7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaVf9R_n8uocRFRTokJf7A5s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_f7d31671-ecf6-48e1-b89a-89c3a508dadd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1800 N Rock Rd Ste 120, Wichita, KS 67206, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, unique snacks, and beautiful flowers. They highlight the affordable prices and the clean, well-stocked store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-5a42-7795-b406-fa159429522d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-5a42-7795-b406-fa159429522d",
        "storage_key": "property/6767906449166547/019d270c-5a42-7795-b406-fa159429522d.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://locations.traderjoes.com/ks/wichita/729/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=15564502814785791359&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "37.7163031",
      "poi_longitude": "-97.2434865",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-634-1846",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8759-715f-8424-120849d82bc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8759-715f-8424-120849d82bc7",
        "storage_key": "property/6767906449166547/019d270c-8759-715f-8424-120849d82bc7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaX4mJJL9uocRf-XfhNg4ANg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_42d051be-a714-4db0-ae6b-06cfad15f75d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Menards",
      "poi_type": "Shopping & Retail",
      "poi_address": "3250 N Toben St, Wichita, KS 67226, USA",
      "poi_short_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_long_description": "People say this home improvement store offers a wide variety of products at reasonable prices, including construction supplies, and is a great place for DIY projects. They also highlight the helpful staff and convenient pick-up option.\n\nSome reviews mention the customer service can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-5a84-7449-8e34-5720f4294e67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-5a84-7449-8e34-5720f4294e67",
        "storage_key": "property/6767906449166547/019d270c-5a84-7449-8e34-5720f4294e67.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.menards.com/store-details/store.html?store=3275&utm_source=localcard&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6112294342705808708&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "menards",
      "poi_latitude": "37.743853",
      "poi_longitude": "-97.230225",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-630-8307",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-87b3-72fa-8d31-5823a6488c24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-87b3-72fa-8d31-5823a6488c24",
        "storage_key": "property/6767906449166547/019d270c-87b3-72fa-8d31-5823a6488c24.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJB4oMUXD9uocRRAWcA1I701Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_34094f34-4b2a-4710-a4b7-01be975594c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "3350 N Woodlawn St, Wichita, KS 67220, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of home items, including paint, and has helpful and friendly staff. They also highlight the competitive prices and good sales.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-5d8b-76ea-8997-bbdaa40ce2e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-5d8b-76ea-8997-bbdaa40ce2e0",
        "storage_key": "property/6767906449166547/019d270c-5d8b-76ea-8997-bbdaa40ce2e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/East-Wichita/KS/Wichita/67220/2204?emt=MSEN?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=10636944138880415122&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "37.7443293",
      "poi_longitude": "-97.2612274",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-681-0899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-87b3-72fa-8d31-5823a6488c24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-87b3-72fa-8d31-5823a6488c24",
        "storage_key": "property/6767906449166547/019d270c-87b3-72fa-8d31-5823a6488c24.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJf_RUnE39uocRkvWjXVYEnpM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_9054efd8-f4a2-45ec-ab91-d65d58796eb1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Wichita State University",
      "poi_type": "Education",
      "poi_address": "1845 Fairmount St, Wichita, KS 67260, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-5e78-7414-9468-62275307011d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-5e78-7414-9468-62275307011d",
        "storage_key": "property/6767906449166547/019d270c-5e78-7414-9468-62275307011d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wichita.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2193094869087118587&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wichita-state-university",
      "poi_latitude": "37.7190782",
      "poi_longitude": "-97.291526",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 316-978-3456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-871a-740e-aa46-8772c4669fc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-871a-740e-aa46-8772c4669fc7",
        "storage_key": "property/6767906449166547/019d270c-871a-740e-aa46-8772c4669fc7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSYDXm-niuocR-2Sr9ilwbx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a31be87b-ebe8-4ab2-a41d-ab0a67895f32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Butler Community College of Andover",
      "poi_type": "Education",
      "poi_address": "5000 Building, 715 E 13th St Room 5012, Andover, KS 67002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-5f4a-765b-8b58-c22bcf2aa891.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-5f4a-765b-8b58-c22bcf2aa891",
        "storage_key": "property/6767906449166547/019d270c-5f4a-765b-8b58-c22bcf2aa891.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.butlercc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8602806853151487120&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "butler-community-college-of-andover",
      "poi_latitude": "37.7074517",
      "poi_longitude": "-97.1275701",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-321-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-871a-740e-aa46-8772c4669fc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-871a-740e-aa46-8772c4669fc7",
        "storage_key": "property/6767906449166547/019d270c-871a-740e-aa46-8772c4669fc7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_X9HUBr_uocRkPRj2UBPY3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_6ffdc177-2ce5-4693-b7c2-b35ca8b5f958",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "WSU Tech | National Center for Aviation Training (NCAT)",
      "poi_type": "Education",
      "poi_address": "4004 N Webb Rd, Wichita, KS 67226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-5ed5-70aa-985b-f81e4e1e82d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-5ed5-70aa-985b-f81e4e1e82d3",
        "storage_key": "property/6767906449166547/019d270c-5ed5-70aa-985b-f81e4e1e82d3.webp",
        "width": 639,
        "height": 359
      },
      "poi_business_url": "https://wsutech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12806940655175411833&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wsu-tech--national-center-for-aviation-training-ncat",
      "poi_latitude": "37.756972",
      "poi_longitude": "-97.2242927",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-677-9400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-871a-740e-aa46-8772c4669fc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-871a-740e-aa46-8772c4669fc7",
        "storage_key": "property/6767906449166547/019d270c-871a-740e-aa46-8772c4669fc7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJA-DVNYACu4cReSg9-6tku7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0d164620-7291-42bc-b2b7-39760f015e01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Woolsey Hall",
      "poi_type": "Education",
      "poi_address": "Student Wellness Center Steve Clark YMCA 2060 N Mid-Campus Drive, Wichita, KS 67208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-624a-7529-8d2a-2463c8e03b6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-624a-7529-8d2a-2463c8e03b6e",
        "storage_key": "property/6767906449166547/019d270c-624a-7529-8d2a-2463c8e03b6e.webp",
        "width": 1280,
        "height": 906
      },
      "poi_business_url": "https://www.wichita.edu/academics/business/woolsey_hall_2022.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=8990881046444541568&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woolsey-hall",
      "poi_latitude": "37.7186727",
      "poi_longitude": "-97.2882013",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 316-978-4792",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-871a-740e-aa46-8772c4669fc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-871a-740e-aa46-8772c4669fc7",
        "storage_key": "property/6767906449166547/019d270c-871a-740e-aa46-8772c4669fc7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-e46vvTjuocRgIYeD60Gxnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_2b576950-9340-41f4-a441-aaa8630a7e8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Charles Koch Arena",
      "poi_type": "Entertainment",
      "poi_address": "1845 Fairmount St, Wichita, KS 67260, USA",
      "poi_short_description": "Huge sporting venue inside Koch Arena hosting basketball games, as well as graduations.",
      "poi_long_description": "People say this arena is a great venue for graduations, sporting events, and concerts. They highlight the easy access, organized entry, and helpful staff. They also like the spacious seating, good views, and large TVs that allow for close-up views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-639d-774f-b2ad-c465f1bdf1e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-639d-774f-b2ad-c465f1bdf1e1",
        "storage_key": "property/6767906449166547/019d270c-639d-774f-b2ad-c465f1bdf1e1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.goshockers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14669727161295634234&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "charles-koch-arena",
      "poi_latitude": "37.7218564",
      "poi_longitude": "-97.2973448",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-978-3267",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8b3a-7003-8041-f606aa44ed9f",
        "storage_key": "property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Q884-_iuocROv_sMCFXlcs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_0e3230bb-51a1-4c76-ab17-11f2cc264f93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Kansas Aviation Museum",
      "poi_type": "Entertainment",
      "poi_address": "3350 George Washington Blvd, Wichita, KS 67210, USA",
      "poi_short_description": "Formerly a municipal airport, with the art deco terminal now housing a tribute to aviation history.",
      "poi_long_description": "Visitors say this museum offers a fascinating look at aviation history, with exhibits on planes, music, and candles. They also highlight the friendly and knowledgeable staff, and the beautiful art deco building and control tower.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-6345-739b-b33e-0f9552840665.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-6345-739b-b33e-0f9552840665",
        "storage_key": "property/6767906449166547/019d270c-6345-739b-b33e-0f9552840665.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.kansasaviationmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11974673674624859714&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kansas-aviation-museum",
      "poi_latitude": "37.632177",
      "poi_longitude": "-97.2736988",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-683-9242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8b0c-76aa-b843-ee0e60ea6140.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8b0c-76aa-b843-ee0e60ea6140",
        "storage_key": "property/6767906449166547/019d270c-8b0c-76aa-b843-ee0e60ea6140.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJnxDQKNfkuocRQn48NUOWLqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_20c9316f-ce8d-4366-921d-e6fd3f29ba6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Cessna Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1845 E 21st St N, Wichita, KS 67260, USA",
      "poi_short_description": "Stadium used for track meets and other sports events with bleachers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-63ff-717e-80a8-dfd363e3429a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-63ff-717e-80a8-dfd363e3429a",
        "storage_key": "property/6767906449166547/019d270c-63ff-717e-80a8-dfd363e3429a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://goshockers.com/sports/2015/5/26/Cessna_Stadium.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1895230992599072842&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cessna-stadium",
      "poi_latitude": "37.7217064",
      "poi_longitude": "-97.2955332",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-978-5556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8b8e-70ac-946b-fafefc0912c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8b8e-70ac-946b-fafefc0912c3",
        "storage_key": "property/6767906449166547/019d270c-8b8e-70ac-946b-fafefc0912c3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHwFEhe_iuocRSsAt4Ys2TRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_30b6cea4-f51f-4a55-abbe-71166acb63ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Frank Lloyd Wright's Allen House",
      "poi_type": "Entertainment",
      "poi_address": "255 N Roosevelt St, Wichita, KS 67208, USA",
      "poi_short_description": "Guided tours through the period interiors of a 1918 Prairie-style home by Frank Lloyd Wright.",
      "poi_long_description": "People say this museum offers an amazing presentation of architecture and a fascinating guided tour. They highlight the historical significance of the house and the knowledgeable docents. They also like the friendly and entertaining tour guides. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-669d-752e-a6bc-59de1be3b238.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-669d-752e-a6bc-59de1be3b238",
        "storage_key": "property/6767906449166547/019d270c-669d-752e-a6bc-59de1be3b238.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://flwrightwichita.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14152560708377734465&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "frank-lloyd-wrights-allen-house",
      "poi_latitude": "37.6897888",
      "poi_longitude": "-97.2924084",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-687-1027",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8b0c-76aa-b843-ee0e60ea6140.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8b0c-76aa-b843-ee0e60ea6140",
        "storage_key": "property/6767906449166547/019d270c-8b0c-76aa-b843-ee0e60ea6140.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJmx3qVRPjuocRQW0BFfv-Z8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_16f78536-40b5-488e-b3ce-b7e6a6f49918",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Eck Stadium - Tyler Field",
      "poi_type": "Entertainment",
      "poi_address": "4100 E 21st St N, Wichita, KS 67208, USA",
      "poi_short_description": "Cozy venue with outfield benches and other seating for college baseball games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-6896-7729-8ff4-327c61715c9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-6896-7729-8ff4-327c61715c9e",
        "storage_key": "property/6767906449166547/019d270c-6896-7729-8ff4-327c61715c9e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://goshockers.com/sports/2015/5/26/Eck_Stadium.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=16739415824998152798&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eck-stadium---tyler-field",
      "poi_latitude": "37.721554",
      "poi_longitude": "-97.2889522",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 316-978-3636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8b8e-70ac-946b-fafefc0912c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8b8e-70ac-946b-fafefc0912c3",
        "storage_key": "property/6767906449166547/019d270c-8b8e-70ac-946b-fafefc0912c3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFcCoDOjiuocRXjqR7ABaTug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_bb3d8ec0-32cf-4b0b-9ecc-157e67230401",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6592 E Central Ave, Wichita, KS 67206, USA",
      "poi_short_description": "Chain gym offering a variety of workout equipment, as well as tanning beds, and massage.",
      "poi_long_description": "People say this gym offers a variety of well-maintained equipment. They also highlight the clean environment and friendly, helpful staff.\n\nOther reviews mention the temperature can be uncomfortable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-698f-770e-bb56-b637606f88a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-698f-770e-bb56-b637606f88a5",
        "storage_key": "property/6767906449166547/019d270c-698f-770e-bb56-b637606f88a5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/wichita-normandie-ks?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=9254476514064462165&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "37.6943986",
      "poi_longitude": "-97.2598706",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-719-3860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8b3a-7003-8041-f606aa44ed9f",
        "storage_key": "property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI2NSzsv8uocRVfEBc1uBboA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f26f4ec3-8468-4992-a7fe-e653550a1fc3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - Rock Road",
      "poi_type": "Health and Wellness",
      "poi_address": "1551 N Rock Rd, Wichita, KS 67206, USA",
      "poi_short_description": "State-of-the-art fitness center chain outlet in Wichita, Kansas, offering a variety of workout options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-6935-720a-bb73-93fc006af714.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-6935-720a-bb73-93fc006af714",
        "storage_key": "property/6767906449166547/019d270c-6935-720a-bb73-93fc006af714.webp",
        "width": 862,
        "height": 485
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/rock-road.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=14856835678487964422&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---rock-road",
      "poi_latitude": "37.7117118",
      "poi_longitude": "-97.245851",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-634-0094",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8b3a-7003-8041-f606aa44ed9f",
        "storage_key": "property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMdkopd_8uocRBuufrlUVLs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_eda08d72-78a9-481a-99cc-4e21a46df99e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - East Harry",
      "poi_type": "Health and Wellness",
      "poi_address": "1607 S Georgetown St, Wichita, KS 67218, USA",
      "poi_short_description": "Spacious fitness center with a swimming pool and a sauna that focuses on helping members reach their goals.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-6b1f-76b3-8352-ebbead3eaecf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-6b1f-76b3-8352-ebbead3eaecf",
        "storage_key": "property/6767906449166547/019d270c-6b1f-76b3-8352-ebbead3eaecf.webp",
        "width": 715,
        "height": 488
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/east-harry.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=8289705737227987081&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---east-harry",
      "poi_latitude": "37.6632431",
      "poi_longitude": "-97.2865009",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-768-8121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8b3a-7003-8041-f606aa44ed9f",
        "storage_key": "property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI6YqvsfluocRiej9f3LzCnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_84945890-4b1a-44ce-9d36-b1b556fb517d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - East Central",
      "poi_type": "Health and Wellness",
      "poi_address": "6100 E Central Ave, Wichita, KS 67208, USA",
      "poi_short_description": "Gym, yoga spot, and fitness center featuring cardio equipment, weight machines and free weights, plus 1-on-1 training.",
      "poi_long_description": "People say this gym offers a wide variety of new and updated equipment, as well as recovery amenities like hydro chairs, a sauna, and a jacuzzi. They also highlight the friendly, helpful, and supportive staff, and the unique, retro vibe with neon lighting.\n\nOther reviews mention the gym can be hot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-6d14-740f-84b0-8bb9b834c4f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-6d14-740f-84b0-8bb9b834c4f1",
        "storage_key": "property/6767906449166547/019d270c-6d14-740f-84b0-8bb9b834c4f1.webp",
        "width": 1280,
        "height": 837
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/east-central.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=16504592488182224350&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---east-central",
      "poi_latitude": "37.6952972",
      "poi_longitude": "-97.2664031",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-681-3010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8b3a-7003-8041-f606aa44ed9f",
        "storage_key": "property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm4G50TTjuocR3pWuRGwXDOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a01e9b7f-3929-4e47-bbfd-306b97594f23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Prime Time Barber Shop East Wichita",
      "poi_type": "Health and Wellness",
      "poi_address": "505 S Woodlawn St, Wichita, KS 67207, USA",
      "poi_short_description": "Barbershop offering haircuts with appointments recommended.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-6d2b-72c8-940f-185d1a03da82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-6d2b-72c8-940f-185d1a03da82",
        "storage_key": "property/6767906449166547/019d270c-6d2b-72c8-940f-185d1a03da82.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://getsquire.com/booking/book/prime-time-barbershop-east-wichita",
      "poi_directions_map_url": "https://maps.google.com/?cid=12886161975853718998&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "prime-time-barber-shop-east-wichita",
      "poi_latitude": "37.6789511",
      "poi_longitude": "-97.2626463",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-400-5697",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8b3a-7003-8041-f606aa44ed9f",
        "storage_key": "property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt9AOcbL9uocR1h3oEAvY1LI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_0762da7a-6baf-4737-a249-b9f215732fd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Classy Nails and Spa Wichita",
      "poi_type": "Health and Wellness",
      "poi_address": "2413 N Greenwich Rd Ste 111, Wichita, KS 67226, USA",
      "poi_short_description": "Clean nail salon offering gel manicures and pedis as well as eyelash extensions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-6ec1-7749-9bc1-bb1c996c1c11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-6ec1-7749-9bc1-bb1c996c1c11",
        "storage_key": "property/6767906449166547/019d270c-6ec1-7749-9bc1-bb1c996c1c11.webp",
        "width": 1096,
        "height": 841
      },
      "poi_business_url": "http://classynailsspawichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5720972690523935251&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "classy-nails-and-spa-wichita",
      "poi_latitude": "37.7267288",
      "poi_longitude": "-97.2087584",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-977-8864",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8b3a-7003-8041-f606aa44ed9f",
        "storage_key": "property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzwYliLD9uocRE9Jj3Fn6ZE8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_db641e7a-3360-461f-9067-a9fbd3620c2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "UrgentPet Care",
      "poi_type": "Health and Wellness",
      "poi_address": "11110 E 26th St N Suite 600, Wichita, KS 67226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-6f7f-73a5-b9e6-700341323dca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-6f7f-73a5-b9e6-700341323dca",
        "storage_key": "property/6767906449166547/019d270c-6f7f-73a5-b9e6-700341323dca.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://urgentpetvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10243324419205437497&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urgentpet-care",
      "poi_latitude": "37.7331206",
      "poi_longitude": "-97.2090998",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-440-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8b3a-7003-8041-f606aa44ed9f",
        "storage_key": "property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoSvzoXb9uocRORjTrUmZJ44",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_fed740a4-1c3e-44a1-b999-bcaced89fe83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "2240 N Rock Rd Ste 105, Wichita, KS 67226, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-71ae-77bd-b319-64ee0804ec27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-71ae-77bd-b319-64ee0804ec27",
        "storage_key": "property/6767906449166547/019d270c-71ae-77bd-b319-64ee0804ec27.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/ks/wichita/2240-n-rock-rd?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=7206197409598942425&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "37.7239676",
      "poi_longitude": "-97.2420689",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-558-5996",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8b3a-7003-8041-f606aa44ed9f",
        "storage_key": "property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh1K2IRj9uocR2Sx8LF2OAWQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_284dba98-415a-4776-a8da-9eeb7d2e75e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "PENTHOUSE NAIL LOUNGE AND SPA",
      "poi_type": "Health and Wellness",
      "poi_address": "8141 E Kellogg Dr Suite 111, Wichita, KS 67207, USA",
      "poi_short_description": "Modern and clean spot specializing in nail care services like manicures and pedicures and acrylics as well as massages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-71d9-776f-9af5-2abb1c0a4353.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-71d9-776f-9af5-2abb1c0a4353",
        "storage_key": "property/6767906449166547/019d270c-71d9-776f-9af5-2abb1c0a4353.webp",
        "width": 1200,
        "height": 1200
      },
      "poi_business_url": "https://penthousenaillounge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16238123041444152354&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "penthouse-nail-lounge-and-spa",
      "poi_latitude": "37.6783945",
      "poi_longitude": "-97.2403687",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-389-6668",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8b3a-7003-8041-f606aa44ed9f",
        "storage_key": "property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA_pKdH39uocRIkRdeN9mWeE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_3ec25c9f-350a-40ee-a198-88f5700e48aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Wesley Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "550 N Hillside St Main Entrance, Wichita, KS 67214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-744f-7128-8fba-193a7f51c251.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-744f-7128-8fba-193a7f51c251",
        "storage_key": "property/6767906449166547/019d270c-744f-7128-8fba-193a7f51c251.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wesleymc.com/locations/wesley-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17159963175428114376&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wesley-medical-center",
      "poi_latitude": "37.6964068",
      "poi_longitude": "-97.2983475",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-962-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8c8c-7031-ae86-6dc701653b4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8c8c-7031-ae86-6dc701653b4f",
        "storage_key": "property/6767906449166547/019d270c-8c8c-7031-ae86-6dc701653b4f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJAxK-0xHjuocRyEctNpdvJO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_fcab5a6a-2734-45e2-8ada-c1655b271e78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Ascension Via Christi St. Joseph",
      "poi_type": "Health and Wellness",
      "poi_address": "3600 E Harry St, Wichita, KS 67218, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-7453-76ba-a1c9-f25b9ab90d92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-7453-76ba-a1c9-f25b9ab90d92",
        "storage_key": "property/6767906449166547/019d270c-7453-76ba-a1c9-f25b9ab90d92.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/kansas/kswic/wichita-ascension-via-christi-st-joseph?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3485178902984589303&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascension-via-christi-st-joseph",
      "poi_latitude": "37.6655529",
      "poi_longitude": "-97.293099",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-268-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8c8c-7031-ae86-6dc701653b4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8c8c-7031-ae86-6dc701653b4f",
        "storage_key": "property/6767906449166547/019d270c-8c8c-7031-ae86-6dc701653b4f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJlflZ053kuocR9_8UO7_XXTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1855e7b6-5d42-48ce-90b4-184218eef67f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Great Plains Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6232 East 29th St N #2200, Wichita, KS 67220, USA",
      "poi_short_description": "Indoor-outdoor facilities designed to educate about the flora & fauna of the Great Plains.",
      "poi_long_description": "People say this nature preserve offers beautiful walking trails, diverse wildlife viewing, and opportunities to connect with nature. They highlight the peaceful and relaxing atmosphere, and the well-maintained trails with informative signage. They also like the friendly people and the availability of benches for observation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-7665-765c-8d72-46fb8666bc3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-7665-765c-8d72-46fb8666bc3f",
        "storage_key": "property/6767906449166547/019d270c-7665-765c-8d72-46fb8666bc3f.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "http://gpnc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16028016397833359637&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-plains-nature-center",
      "poi_latitude": "37.73924",
      "poi_longitude": "-97.263722",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-683-5499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8edf-72e4-bf1a-62d16eeb0ccf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8edf-72e4-bf1a-62d16eeb0ccf",
        "storage_key": "property/6767906449166547/019d270c-8edf-72e4-bf1a-62d16eeb0ccf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvcw5n0z9uocRFVH-Zv7zbt4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_b3e28e30-ec05-4b74-9bd1-ebd1ae9f41f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Fairmount Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1647 N Yale Blvd, Wichita, KS 67218, USA",
      "poi_short_description": "Spacious park featuring a playground, a splash fountain and a community center.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-76be-77e0-91b6-7e67c6cddbfe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-76be-77e0-91b6-7e67c6cddbfe",
        "storage_key": "property/6767906449166547/019d270c-76be-77e0-91b6-7e67c6cddbfe.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/Fairmount-Park-37",
      "poi_directions_map_url": "https://maps.google.com/?cid=11580955339775493795&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fairmount-park",
      "poi_latitude": "37.7127054",
      "poi_longitude": "-97.29159",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-268-4361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8edf-72e4-bf1a-62d16eeb0ccf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8edf-72e4-bf1a-62d16eeb0ccf",
        "storage_key": "property/6767906449166547/019d270c-8edf-72e4-bf1a-62d16eeb0ccf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3aE5LuLiuocRo0b74oXRt6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_f53ec382-ef01-4ed8-8fe2-00dfb3327474",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "L.W. Clapp Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4611 E Harry St, Wichita, KS 67218, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-7a07-77d2-8f60-4292d830e894.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-7a07-77d2-8f60-4292d830e894",
        "storage_key": "property/6767906449166547/019d270c-7a07-77d2-8f60-4292d830e894.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/LW-Clapp-Memorial-Park-162",
      "poi_directions_map_url": "https://maps.google.com/?cid=11495452650844501100&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lw-clapp-park",
      "poi_latitude": "37.6623254",
      "poi_longitude": "-97.2828208",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-688-9341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8edf-72e4-bf1a-62d16eeb0ccf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8edf-72e4-bf1a-62d16eeb0ccf",
        "storage_key": "property/6767906449166547/019d270c-8edf-72e4-bf1a-62d16eeb0ccf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJa5z3WKLkuocRbLToyUcNiJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_235b0d1d-00f3-435d-ab1d-f80e6a44f3d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Edgemoor Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5815 E 9th St N, Wichita, KS 67208, USA",
      "poi_short_description": "Park featuring a splash pad and skate park along with basketball and tennis courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-7a11-7488-bfcf-69ffc98f95f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-7a11-7488-bfcf-69ffc98f95f3",
        "storage_key": "property/6767906449166547/019d270c-7a11-7488-bfcf-69ffc98f95f3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/Edgemoor-Park-20",
      "poi_directions_map_url": "https://maps.google.com/?cid=14777509089755302817&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "edgemoor-park",
      "poi_latitude": "37.70038470000001",
      "poi_longitude": "-97.2688025",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-268-4361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8edf-72e4-bf1a-62d16eeb0ccf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8edf-72e4-bf1a-62d16eeb0ccf",
        "storage_key": "property/6767906449166547/019d270c-8edf-72e4-bf1a-62d16eeb0ccf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxST4RjLjuocRoYv49zhCFM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_3ee32130-4731-473f-b43c-1ccefdda5daa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "MacDonald Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "840 N Yale Ave, Wichita, KS 67208, USA",
      "poi_short_description": "Public city 18-hole golf course dotted with ponds & mature trees & offering golf carts.",
      "poi_long_description": "Public city 18-hole golf course dotted with ponds & mature trees & offering golf carts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-7b00-7479-bdba-0ee89568ab14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-7b00-7479-bdba-0ee89568ab14",
        "storage_key": "property/6767906449166547/019d270c-7b00-7479-bdba-0ee89568ab14.webp",
        "width": 1280,
        "height": 279
      },
      "poi_business_url": "https://www.wichita.gov/facilities/facility/details/MacDonald-Golf-Course-149",
      "poi_directions_map_url": "https://maps.google.com/?cid=12364549608739728143&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "macdonald-golf-course",
      "poi_latitude": "37.6986098",
      "poi_longitude": "-97.2919043",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-688-9391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8fc2-715a-aaba-e834ff104b3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8fc2-715a-aaba-e834ff104b3f",
        "storage_key": "property/6767906449166547/019d270c-8fc2-715a-aaba-e834ff104b3f.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJATNFVBjjuocRD2ug5Fu0l6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_dd6794e8-873c-44dc-b049-df0f723d9eee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Colonel James Jabara Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3512 N Webb Rd, Wichita, KS 67226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-7bd7-7274-aa55-a4f2e0e86694.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-7bd7-7274-aa55-a4f2e0e86694",
        "storage_key": "property/6767906449166547/019d270c-7bd7-7274-aa55-a4f2e0e86694.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flywichita.com/general-aviation-jabara/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4247184628307720702&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "colonel-james-jabara-airport",
      "poi_latitude": "37.747501",
      "poi_longitude": "-97.221107",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-636-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-900b-74ae-829a-36aea31220ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-900b-74ae-829a-36aea31220ca",
        "storage_key": "property/6767906449166547/019d270c-900b-74ae-829a-36aea31220ca.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2QXGMHj9uocR_vnHueoH8To",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_df7a193b-1398-45c4-969a-bd59b2523944",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "United States Department-The Air Force",
      "poi_type": "Transportation & Transit",
      "poi_address": "53280 Topeka St # 221, McConnell AFB, KS 67221, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-7e26-7461-971a-c9dc2dec60d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-7e26-7461-971a-c9dc2dec60d7",
        "storage_key": "property/6767906449166547/019d270c-7e26-7461-971a-c9dc2dec60d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15137253015023024284&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "united-states-department-the-air-force",
      "poi_latitude": "37.6347274",
      "poi_longitude": "-97.2563934",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 800-864-8331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-900b-74ae-829a-36aea31220ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-900b-74ae-829a-36aea31220ca",
        "storage_key": "property/6767906449166547/019d270c-900b-74ae-829a-36aea31220ca.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ98NSryj7uocRnHioo2pTEtI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_ae9951d3-959f-4402-add3-6285a1723d11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Beech Factory Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "9709 E Central Ave, Wichita, KS 67206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-7f17-706d-8acf-368029d81448.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-7f17-706d-8acf-368029d81448",
        "storage_key": "property/6767906449166547/019d270c-7f17-706d-8acf-368029d81448.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.beechcraft.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2405539519632020958&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "beech-factory-airport",
      "poi_latitude": "37.694119",
      "poi_longitude": "-97.222706",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-900b-74ae-829a-36aea31220ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-900b-74ae-829a-36aea31220ca",
        "storage_key": "property/6767906449166547/019d270c-900b-74ae-829a-36aea31220ca.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJL2fuq2D8uocR3pXUsHIxYiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_201b78ff-5ab1-4e4f-95ae-57b132e0a3f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Cessna Aircraft Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "7751 E Pawnee St, Wichita, KS 67207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4990377361051433458&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cessna-aircraft-field",
      "poi_latitude": "37.6495235",
      "poi_longitude": "-97.2505854",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-831-4036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-900b-74ae-829a-36aea31220ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-900b-74ae-829a-36aea31220ca",
        "storage_key": "property/6767906449166547/019d270c-900b-74ae-829a-36aea31220ca.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJHwjn_MjjuocR8jmfDMVhQUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_801b404c-fd13-4a4e-a0a2-9cb26b443701",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Textron Aviation Career & Learning Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "293 S Greenwich Rd Suite 400, Wichita, KS 67206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://txtav.com/en/careers/career-learning-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=17738308330864323395&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "textron-aviation-career--learning-center",
      "poi_latitude": "37.6827328",
      "poi_longitude": "-97.2112662",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-515-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8b3a-7003-8041-f606aa44ed9f",
        "storage_key": "property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN6sjFQD9uocRQyuFAXIhK_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_24c8c688-abca-43ac-9dd5-12996023561e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Airbus Americas Engineering",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1855 Innovation Blvd, Wichita, KS 67208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8042-72c4-952d-caaea06b37f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-8042-72c4-952d-caaea06b37f8",
        "storage_key": "property/6767906449166547/019d270c-8042-72c4-952d-caaea06b37f8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.airbus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2717662062190135635&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "airbus-americas-engineering",
      "poi_latitude": "37.717177",
      "poi_longitude": "-97.2864877",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 316-299-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8b3a-7003-8041-f606aa44ed9f",
        "storage_key": "property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw6cW5d3iuocRUwlmLD8TtyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e91eb148-f8d4-4e61-9b6c-86ecb58a61db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Goodwill Industries of Kansas Administration & NexStep Alliance",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3351 N Webb Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Long-standing nonprofit chain with a range of pre-owned clothing, furniture, housewares & more.",
      "poi_long_description": "Long-standing nonprofit chain with a range of pre-owned clothing, furniture, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-81a7-70e9-a242-25d065d67e45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-81a7-70e9-a242-25d065d67e45",
        "storage_key": "property/6767906449166547/019d270c-81a7-70e9-a242-25d065d67e45.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://goodwillks.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2600486553204831060&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "goodwill-industries-of-kansas-administration--nexstep-alliance",
      "poi_latitude": "37.744572",
      "poi_longitude": "-97.2273",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-744-9291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8b3a-7003-8041-f606aa44ed9f",
        "storage_key": "property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTXAYzXD9uocRVDP0_r3IFiQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_13c4dd85-9aaf-4b2c-913b-89bbf6288f9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "WIC Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1131 S Clifton Ave, Wichita, KS 67218, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.sedgwickcounty.org/health/services-and-providers/women-infants-and-children-wic/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15592591238908059629&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wic-office",
      "poi_latitude": "37.6673061",
      "poi_longitude": "-97.2945491",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-660-7444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8b3a-7003-8041-f606aa44ed9f",
        "storage_key": "property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi5dkX4jluocR7Z_7Yh4DZNg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c9c2a49c-4d8a-480f-b81f-c71223a77ae3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Freddy's Frozen Custard - HQ",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3020 N Cypress Dr Suite 200, Wichita, KS 67226, USA",
      "poi_short_description": "Vintage-style chain for steakburgers, hot dogs & other fast-food staples, plus frozen custard.",
      "poi_long_description": "Vintage-style chain for steakburgers, hot dogs & other fast-food staples, plus frozen custard.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8265-773c-99cf-78fcdcc65b34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270c-8265-773c-99cf-78fcdcc65b34",
        "storage_key": "property/6767906449166547/019d270c-8265-773c-99cf-78fcdcc65b34.webp",
        "width": 600,
        "height": 450
      },
      "poi_business_url": "https://www.freddys.com/?utm_source=gbp&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=13102723026135156589&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "freddys-frozen-custard---hq",
      "poi_latitude": "37.7402941",
      "poi_longitude": "-97.2310622",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-719-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270c-8b3a-7003-8041-f606aa44ed9f",
        "storage_key": "property/6767906449166547/019d270c-8b3a-7003-8041-f606aa44ed9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf-eBg5X8uocRbQceyys51rU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a77599b9-e324-409b-968f-be2c9b0c7a74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Minneha Core Knowledge Magnet Elementary School",
      "poi_type": "Education",
      "poi_address": "701 N Webb Rd, Wichita, KS 67206, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d7915-c06d-77dd-8d02-939df7f06e23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-c06d-77dd-8d02-939df7f06e23",
        "storage_key": "property/6767906449166547/019d7915-c06d-77dd-8d02-939df7f06e23.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://minneha.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11875990731365639913&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "minneha-core-knowledge-magnet-elementary-school",
      "poi_latitude": "37.6969577",
      "poi_longitude": "-97.2271449",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-973-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-621f-738e-84fc-95866f3600ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-621f-738e-84fc-95866f3600ac",
        "storage_key": "property/6767906449166547/019cfb4f-621f-738e-84fc-95866f3600ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG_2td_T8uocR6WbhAqb-z6Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_91476ad6-6671-4df4-b211-459349030285",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Robert M. Martin Elementary School",
      "poi_type": "Education",
      "poi_address": "2342 North 159th St E, Wichita, KS 67228, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d7915-bcdd-70d7-9624-0cc6de66478b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-bcdd-70d7-9624-0cc6de66478b",
        "storage_key": "property/6767906449166547/019d7915-bcdd-70d7-9624-0cc6de66478b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://martin.usd385.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7521246417709956592&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "robert-m-martin-elementary-school",
      "poi_latitude": "37.7285817",
      "poi_longitude": "-97.1516278",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-218-4720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-621f-738e-84fc-95866f3600ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-621f-738e-84fc-95866f3600ac",
        "storage_key": "property/6767906449166547/019cfb4f-621f-738e-84fc-95866f3600ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD-nsXf3-uocR8P3Hg8TVYGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a76deada-dde7-4b2c-b89d-e41ceebe8ef4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Andover Middle School",
      "poi_type": "Education",
      "poi_address": "1628 N Andover Rd, Andover, KS 67002, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://ams.usd385.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2536425095234994916&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "andover-middle-school",
      "poi_latitude": "37.71530509999999",
      "poi_longitude": "-97.1330773",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-218-4610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-621f-738e-84fc-95866f3600ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-621f-738e-84fc-95866f3600ac",
        "storage_key": "property/6767906449166547/019cfb4f-621f-738e-84fc-95866f3600ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ966oEQL_uocR5ELegC8xMyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_3b959b7e-a488-4ae7-9b70-37568113551f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Robinson Middle School",
      "poi_type": "Education",
      "poi_address": "328 N Oliver St, Wichita, KS 67208, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://robinson.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1770295188833297893&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "robinson-middle-school",
      "poi_latitude": "37.6910779",
      "poi_longitude": "-97.2796099",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-973-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-621f-738e-84fc-95866f3600ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-621f-738e-84fc-95866f3600ac",
        "storage_key": "property/6767906449166547/019cfb4f-621f-738e-84fc-95866f3600ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9y9ZkDjjuocR5eX9RRhakRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_ca8252b0-3703-4853-8583-0adb01dfc8fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Wichita Collegiate School",
      "poi_type": "Education",
      "poi_address": "9115 E 13th St N, Wichita, KS 67206, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d7915-bd9e-710d-9f21-f0f7e3837681.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-bd9e-710d-9f21-f0f7e3837681",
        "storage_key": "property/6767906449166547/019d7915-bd9e-710d-9f21-f0f7e3837681.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.wcsks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6161546641279598679&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-collegiate-school",
      "poi_latitude": "37.7070832",
      "poi_longitude": "-97.2314664",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-634-0433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-621f-738e-84fc-95866f3600ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-621f-738e-84fc-95866f3600ac",
        "storage_key": "property/6767906449166547/019cfb4f-621f-738e-84fc-95866f3600ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMeE4GPv8uocRV8B4ZAY2glU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_65f04ef6-39a3-4d3a-8123-1baf16380a24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Wichita Southeast High School",
      "poi_type": "Education",
      "poi_address": "2641 S 127th St E, Wichita, KS 67210, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d7915-bde2-7770-8fc2-567078d20b98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-bde2-7770-8fc2-567078d20b98",
        "storage_key": "property/6767906449166547/019d7915-bde2-7770-8fc2-567078d20b98.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://usd259.org/southeast",
      "poi_directions_map_url": "https://maps.google.com/?cid=8092226210509851341&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-southeast-high-school",
      "poi_latitude": "37.6460207",
      "poi_longitude": "-97.19266",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-973-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-621f-738e-84fc-95866f3600ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-621f-738e-84fc-95866f3600ac",
        "storage_key": "property/6767906449166547/019cfb4f-621f-738e-84fc-95866f3600ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIQxmO8T7uocRzYqLL91cTXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_4ac5d43f-f3fb-4ded-a63a-c0dac785a7c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "First Mile Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "2141 N Bradley Fair Pkwy #111, Wichita, KS 67206, USA",
      "poi_short_description": "Relaxed spot for locally sourced goods featuring wood-fired eats, inventive cocktails, and a wine list.",
      "poi_long_description": "People say this restaurant serves delicious salmon, pork, and lobster deviled eggs. They also highlight the great wine selection, tasty desserts, and the friendly and helpful staff.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d7915-c775-766a-8668-feae4a3dcfdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-c775-766a-8668-feae4a3dcfdb",
        "storage_key": "property/6767906449166547/019d7915-c775-766a-8668-feae4a3dcfdb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.firstmilekitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16753804929406160331&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "first-mile-kitchen",
      "poi_latitude": "37.7221719",
      "poi_longitude": "-97.2421475",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-358-0130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-622c-74c8-9e7c-5a2ac080046e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-622c-74c8-9e7c-5a2ac080046e",
        "storage_key": "property/6767906449166547/019cfb4f-622c-74c8-9e7c-5a2ac080046e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv8HFXq79uocRy01xXdF4geg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6a35d7de-6e42-42af-a084-32ba5a4cb28b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Scotch & Sirloin",
      "poi_type": "Restaurants",
      "poi_address": "5325 E Kellogg Dr, Wichita, KS 67218, USA",
      "poi_short_description": "Established steakhouse well known for choice local beef along with seafood & side dishes.",
      "poi_long_description": "People say this steakhouse serves delicious prime rib, filet mignon, and steak poppers. They also highlight the excellent service, top-notch drinks, and classic, refined atmosphere.\n\nOther reviews mention the steaks can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d7915-cb44-75d8-a641-15f0d2ace47a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-cb44-75d8-a641-15f0d2ace47a",
        "storage_key": "property/6767906449166547/019d7915-cb44-75d8-a641-15f0d2ace47a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.scotchandsirloin.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3750097833173709529&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "scotch-sirloin",
      "poi_latitude": "37.6783056",
      "poi_longitude": "-97.2743139",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-685-8701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-622c-74c8-9e7c-5a2ac080046e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-622c-74c8-9e7c-5a2ac080046e",
        "storage_key": "property/6767906449166547/019cfb4f-622c-74c8-9e7c-5a2ac080046e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZVCNQ1DjuocR2fJHQxwGCzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_4d2651ca-a836-4fa0-88bb-e6d4cb7d0108",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "FioRito Ristorante",
      "poi_type": "Restaurants",
      "poi_address": "3134 E Douglas Ave, Wichita, KS 67214, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this restaurant serves delicious, unique Italian dishes, including homemade pasta, focaccia, and specials like white lasagna and beef-stuffed cappelletti. They highlight the cozy, converted gas station atmosphere and the attentive, friendly service. They also like the generous portions and the availability of vegetarian, gluten-free, and vegan options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d7915-cd91-7480-be1d-1f7601f039cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-cd91-7480-be1d-1f7601f039cd",
        "storage_key": "property/6767906449166547/019d7915-cd91-7480-be1d-1f7601f039cd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fioritoristorante.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1815645630715687570&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fiorito-ristorante",
      "poi_latitude": "37.686676",
      "poi_longitude": "-97.2994079",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-364-4707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-622c-74c8-9e7c-5a2ac080046e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-622c-74c8-9e7c-5a2ac080046e",
        "storage_key": "property/6767906449166547/019cfb4f-622c-74c8-9e7c-5a2ac080046e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQT0XnKvjuocRknLM2BR4Mhk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b153cfca-df72-46ec-9fac-1f0a46233a0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Vora Restaurant European",
      "poi_type": "Restaurants",
      "poi_address": "3252 E Douglas Ave, Wichita, KS 67214, USA",
      "poi_short_description": "false",
      "poi_long_description": "Diners say this European restaurant serves up delicious lasagna, French onion soup, and calamari, and they praise the extensive wine selection and espresso martinis. They also highlight the friendly and attentive service, and the elegant and fun atmosphere, making it perfect for a date night or celebration.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d7915-d408-726c-8c46-30d258ed634d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-d408-726c-8c46-30d258ed634d",
        "storage_key": "property/6767906449166547/019d7915-d408-726c-8c46-30d258ed634d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://vorawichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15521881902930634343&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "vora-restaurant-european",
      "poi_latitude": "37.6865212",
      "poi_longitude": "-97.2967693",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-977-9277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-622c-74c8-9e7c-5a2ac080046e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-622c-74c8-9e7c-5a2ac080046e",
        "storage_key": "property/6767906449166547/019cfb4f-622c-74c8-9e7c-5a2ac080046e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVyKVdK3juocRZ6a-LVrNaNc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "european_restaurant"
    },
    {
      "id": "custom_0fb5a497-d932-4186-9809-bfc993f4ebfd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "323 N Rock Rd, Wichita, KS 67206, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "People say this Italian restaurant serves delicious pasta, salad, and breadsticks. They also highlight the excellent service and friendly staff.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d7915-d8a0-71b0-baa7-cc2d90f9edfe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-d8a0-71b0-baa7-cc2d90f9edfe",
        "storage_key": "property/6767906449166547/019d7915-d8a0-71b0-baa7-cc2d90f9edfe.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.olivegarden.com/locations/ks/wichita/wichita-town-east-mall/1224?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:wichita-ks-1224_pl:locurl_rd:1166",
      "poi_directions_map_url": "https://maps.google.com/?cid=13527655343449245053&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "37.691381",
      "poi_longitude": "-97.2452",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-684-6757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-622c-74c8-9e7c-5a2ac080046e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-622c-74c8-9e7c-5a2ac080046e",
        "storage_key": "property/6767906449166547/019cfb4f-622c-74c8-9e7c-5a2ac080046e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMzBvlr_8uocRfQU1vtziu7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_8c7bb535-28c0-4ade-9dcb-ce7d52d14da8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Meddys",
      "poi_type": "Restaurants",
      "poi_address": "2300 N Greenwich Rd Ste 100, Wichita, KS 67226, USA",
      "poi_short_description": "Shawarma, falafel & other Mediterranean standards round out the menu at this simple counter serve.",
      "poi_long_description": "People say this Mediterranean restaurant serves delicious food, including garlic chicken, falafel, and shawarma. They highlight the generous portions, reasonable prices, and fresh ingredients. They also like the friendly and attentive service, and the beautiful outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d7915-ddbc-70f4-9fc8-0fbdb0f29daa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-ddbc-70f4-9fc8-0fbdb0f29daa",
        "storage_key": "property/6767906449166547/019d7915-ddbc-70f4-9fc8-0fbdb0f29daa.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.meddys.com/contact-us/locations/meddys-greenwich/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15290987150177078035&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "meddys",
      "poi_latitude": "37.7248427",
      "poi_longitude": "-97.2071962",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-425-6871",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-622c-74c8-9e7c-5a2ac080046e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-622c-74c8-9e7c-5a2ac080046e",
        "storage_key": "property/6767906449166547/019cfb4f-622c-74c8-9e7c-5a2ac080046e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHYUfwrD9uocREwteR8x_NNQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_8b8ff6b8-8960-405c-a784-41c67b26231b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Angelo's Italian Restaurant - Wichita",
      "poi_type": "Restaurants",
      "poi_address": "5900 E Central Ave # 100, Wichita, KS 67208, USA",
      "poi_short_description": "Contemporary, relaxed Italian restaurant serving pizza, sandwiches & classic entrees since 1959.",
      "poi_long_description": "People say this Italian restaurant serves delicious pasta dishes, pizzas, and Sicilian thighs. They highlight the generous portions, reasonable prices, and authentic Italian flavors. They also like the attentive service and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d7915-dc82-7061-8f28-310b2e6b3dd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-dc82-7061-8f28-310b2e6b3dd5",
        "storage_key": "property/6767906449166547/019d7915-dc82-7061-8f28-310b2e6b3dd5.webp",
        "width": 720,
        "height": 960
      },
      "poi_business_url": "https://www.angeloswichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13509147296038509125&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "angelo-s-italian-restaurant-wichita",
      "poi_latitude": "37.6941364",
      "poi_longitude": "-97.2678911",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-364-7913",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-622c-74c8-9e7c-5a2ac080046e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-622c-74c8-9e7c-5a2ac080046e",
        "storage_key": "property/6767906449166547/019cfb4f-622c-74c8-9e7c-5a2ac080046e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPfmjAzfjuocRRdrNJuQhers",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_1317fd52-8bd0-4ee7-b654-82adc4942dc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "10800 E 21st St N, Wichita, KS 67206, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store has a wide selection of products. They also highlight the kind and courteous employees, and the minimal checkout time.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d7915-df28-75ee-a550-ba0f5cf26e35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-df28-75ee-a550-ba0f5cf26e35",
        "storage_key": "property/6767906449166547/019d7915-df28-75ee-a550-ba0f5cf26e35.webp",
        "width": 1140,
        "height": 749
      },
      "poi_business_url": "https://www.target.com/sl/wichita-ne/1944",
      "poi_directions_map_url": "https://maps.google.com/?cid=6067598449320791704&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "37.724525",
      "poi_longitude": "-97.2123712",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-636-4206",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-6208-77a9-ac82-068b55a5edcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-6208-77a9-ac82-068b55a5edcd",
        "storage_key": "property/6767906449166547/019cfb4f-6208-77a9-ac82-068b55a5edcd.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJazbbMa79uocRmA56Y6RwNFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_f4926316-6f5f-401d-bca5-3e49e7c57301",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "11411 E Kellogg Dr, Wichita, KS 67207, USA",
      "poi_short_description": "Multi-area superstore selling groceries and electronics, plus a selection of athletic gear, furniture and toys.",
      "poi_long_description": "People say this department store offers a wide variety of products and affordable prices.\n\nOther reviews mention the self-checkout can be inconvenient and the customer service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d7915-e53f-77d8-b056-9c494e9115cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-e53f-77d8-b056-9c494e9115cd",
        "storage_key": "property/6767906449166547/019d7915-e53f-77d8-b056-9c494e9115cd.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/3492-wichita-ks/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3954238012201378577&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "37.6766357",
      "poi_longitude": "-97.2044906",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-683-0735",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-6208-77a9-ac82-068b55a5edcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-6208-77a9-ac82-068b55a5edcd",
        "storage_key": "property/6767906449166547/019cfb4f-6208-77a9-ac82-068b55a5edcd.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJGQWTgHP8uocRESOcioVG4DY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_8b315405-f64e-43a5-8807-ed5828cd3208",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "T.J. Maxx",
      "poi_type": "Shopping & Retail",
      "poi_address": "8125 E Kellogg Dr, Wichita, KS 67207, USA",
      "poi_short_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_long_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d7915-e9c8-71d1-a3a4-22471d74589e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-e9c8-71d1-a3a4-22471d74589e",
        "storage_key": "property/6767906449166547/019d7915-e9c8-71d1-a3a4-22471d74589e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://tjmaxx.tjx.com/store/index.jsp",
      "poi_directions_map_url": "https://maps.google.com/?cid=15969857209197098623&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "t-j-maxx",
      "poi_latitude": "37.677777",
      "poi_longitude": "-97.241785",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-681-0286",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-6208-77a9-ac82-068b55a5edcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-6208-77a9-ac82-068b55a5edcd",
        "storage_key": "property/6767906449166547/019cfb4f-6208-77a9-ac82-068b55a5edcd.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJs9keFpn8uocRf3bnE4VUoN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_391583f2-453e-43ec-bfe4-a8021f9cbde0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "H&M",
      "poi_type": "Shopping & Retail",
      "poi_address": "7700 E Kellogg Dr M04A, Wichita, KS 67207, USA",
      "poi_short_description": "Chain retailer supplying on-trend clothing, swimwear, accessories & shoes.",
      "poi_long_description": "Chain retailer supplying on-trend clothing, swimwear, accessories & shoes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d7915-eb90-71ed-a1f3-397cd8e500c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-eb90-71ed-a1f3-397cd8e500c9",
        "storage_key": "property/6767906449166547/019d7915-eb90-71ed-a1f3-397cd8e500c9.webp",
        "width": 1280,
        "height": 531
      },
      "poi_business_url": "https://www2.hm.com/en_us/customer-service/shopping-at-hm/store-locator/usa/wichita/towne-east-square/US0614.html?utm_source=google_location&utm_medium=organic&utm_content=US0614&utm_campaign=pi_USQ00AAU0AA004",
      "poi_directions_map_url": "https://maps.google.com/?cid=14559652267242071966&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "h-m",
      "poi_latitude": "37.6841867",
      "poi_longitude": "-97.2473818",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 855-466-7467",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-6208-77a9-ac82-068b55a5edcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-6208-77a9-ac82-068b55a5edcd",
        "storage_key": "property/6767906449166547/019cfb4f-6208-77a9-ac82-068b55a5edcd.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ190U27z8uocRnqcswphGDso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_293663a8-6188-4a79-84d0-0b4351481335",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Dillard's",
      "poi_type": "Shopping & Retail",
      "poi_address": "7700 E Kellogg St, Wichita, KS 67207, USA",
      "poi_short_description": "Department store chain with apparel, shoes & accessories, plus beauty products & home goods.",
      "poi_long_description": "People say this department store offers a great selection of clothing, shoes, and accessories. They also highlight the helpful staff and the availability of sales.\n\nOther reviews mention the return policy can be restrictive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d7915-f120-775b-b74f-724192241e0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f120-775b-b74f-724192241e0a",
        "storage_key": "property/6767906449166547/019d7915-f120-775b-b74f-724192241e0a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.dillards.com/stores/kansas/towne-east-square-wichita/0330",
      "poi_directions_map_url": "https://maps.google.com/?cid=13245552038651125755&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dillard-s",
      "poi_latitude": "37.684821",
      "poi_longitude": "-97.2472437",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-685-0341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-6208-77a9-ac82-068b55a5edcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-6208-77a9-ac82-068b55a5edcd",
        "storage_key": "property/6767906449166547/019cfb4f-6208-77a9-ac82-068b55a5edcd.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJCaEvc6P8uocR-1_AtWan0bc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_5361f7ca-c1e1-4514-9beb-a3edd24932f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Sedgwick County Zoo",
      "poi_type": "Entertainment",
      "poi_address": "5555 W Zoo Blvd, Wichita, KS 67212, USA",
      "poi_short_description": "Animals organized by continent, plus educational programs for various age groups.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including baby elephants, and has spacious, well-designed habitats that mimic natural environments. They highlight the zoo is clean, well-organized, and easy to navigate, with plenty of rest areas and shaded spots. They also like the friendly, knowledgeable, and passionate staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d7915-f323-73eb-a22c-0b4929e334d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f323-73eb-a22c-0b4929e334d6",
        "storage_key": "property/6767906449166547/019d7915-f323-73eb-a22c-0b4929e334d6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://scz.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11432857233417595508&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sedgwick-county-zoo",
      "poi_latitude": "37.717034",
      "poi_longitude": "-97.408561",
      "poi_miles_from_property": "13.9 mi",
      "poi_walking_minutes": "5 hours 7 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 316-660-9453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-6208-77a9-ac82-090d84f93965.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-6208-77a9-ac82-090d84f93965",
        "storage_key": "property/6767906449166547/019cfb4f-6208-77a9-ac82-090d84f93965.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDVutukTguocRdGqcdRSrqZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_b7817f49-ad5d-4e6d-88be-30a72c2b2d68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Botanica, The Wichita Gardens",
      "poi_type": "Entertainment",
      "poi_address": "701 Amidon St, Wichita, KS 67203, USA",
      "poi_short_description": "Imaginative, verdant botanical garden with children's areas, a butterfly house, events & more.",
      "poi_long_description": "People say this botanical garden offers beautiful gardens, a butterfly house, and a children's area with a carousel and playground. They highlight the tranquil and peaceful atmosphere, and the well-maintained grounds with labeled plants and artistic sculptures. They also like the fun and engaging activities for children, such as the splash area and treehouse.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d7915-fa7a-773d-b2f6-f70e7b06a993.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-fa7a-773d-b2f6-f70e7b06a993",
        "storage_key": "property/6767906449166547/019d7915-fa7a-773d-b2f6-f70e7b06a993.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.botanica.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14898597451770473856&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "botanica-the-wichita-gardens",
      "poi_latitude": "37.6964308",
      "poi_longitude": "-97.361781",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 41 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 316-264-0448",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-6208-77a9-ac82-090d84f93965.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-6208-77a9-ac82-090d84f93965",
        "storage_key": "property/6767906449166547/019cfb4f-6208-77a9-ac82-090d84f93965.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeda7xm_huocRgK1RPHJzws4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_ad556d12-29d3-488f-b84a-5fe4ae44bdae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Wichita Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "1400 Museum Blvd, Wichita, KS 67203, USA",
      "poi_short_description": "Contemporary & historical works from a 7,000-piece permanent collection, & a hands-on area for kids.",
      "poi_long_description": "People say this art museum offers a diverse collection of paintings, photography, and sculptures, including works by local artists and traveling exhibits. They highlight the free general admission, the clean and well-maintained facility, and the fun events and children's area. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d7915-f91e-7594-996e-8082b7b0c85a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f91e-7594-996e-8082b7b0c85a",
        "storage_key": "property/6767906449166547/019d7915-f91e-7594-996e-8082b7b0c85a.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://wam.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14953396795402545430&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-art-museum",
      "poi_latitude": "37.6949197",
      "poi_longitude": "-97.3559687",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 316-268-4921",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-621f-738e-84fc-98269e201188.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-621f-738e-84fc-98269e201188",
        "storage_key": "property/6767906449166547/019cfb4f-621f-738e-84fc-98269e201188.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJu0d-QWPhuocRFulurygjhc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_6b9654f0-9226-4b35-a65b-966239da887c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Roxy's Downtown",
      "poi_type": "Entertainment",
      "poi_address": "412, 2 E Douglas Ave #1, Wichita, KS 67202, USA",
      "poi_short_description": "Casual theater featuring dramatic plays, musical comedy productions, and themed menu items.",
      "poi_long_description": "People say this performing arts theater puts on a variety of well-done shows, with many mentioning Legally Blonde and Into the Woods as favorites. They also highlight the delicious food and drinks, especially the vegetarian options and themed cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d7916-01e4-74cc-a238-f3ea35d1c661.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-01e4-74cc-a238-f3ea35d1c661",
        "storage_key": "property/6767906449166547/019d7916-01e4-74cc-a238-f3ea35d1c661.webp",
        "width": 1280,
        "height": 955
      },
      "poi_business_url": "http://www.roxysdowntown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12780774180450247029&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "roxy-s-downtown",
      "poi_latitude": "37.6862038",
      "poi_longitude": "-97.3337274",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-265-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-6208-77a9-ac82-090d84f93965.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-6208-77a9-ac82-090d84f93965",
        "storage_key": "property/6767906449166547/019cfb4f-6208-77a9-ac82-090d84f93965.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrQVCburjuocRdaE41GZuXrE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_eaa1dd89-63e6-4236-a2b1-fd3fdb399b87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "The Arcade",
      "poi_type": "Entertainment",
      "poi_address": "906 E 3rd St N, Wichita, KS 67202, USA",
      "poi_short_description": "Massive collection of 80s and 90s arcade and pinball games, plus skeeball.",
      "poi_long_description": "People say this video arcade offers a wide selection of retro games, pinball machines, and skeeball, as well as pizza, pretzel bites, and boneless wings. They highlight the affordable prices, fun, nostalgic vibe, and family-friendly atmosphere. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019d7915-fff7-7302-95a7-5e2c04466d6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-fff7-7302-95a7-5e2c04466d6b",
        "storage_key": "property/6767906449166547/019d7915-fff7-7302-95a7-5e2c04466d6b.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://thearcadewichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15352356485640783401&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-arcade",
      "poi_latitude": "37.6918989",
      "poi_longitude": "-97.3272892",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 316-730-0998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-6208-77a9-ac82-090d84f93965.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-6208-77a9-ac82-090d84f93965",
        "storage_key": "property/6767906449166547/019cfb4f-6208-77a9-ac82-090d84f93965.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ759z4r_juocRKYbIJ-KGDtU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "video_arcade"
    },
    {
      "id": "custom_ae96b317-0d8c-470b-95dc-af5c7323cb0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Town East Square (shopping mall)",
      "poi_type": "Shopping & Retail",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "town-east-square-shopping-mall",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d37fd633-23a8-46b1-a85a-895c4a283380",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Forever 21",
      "poi_type": "Shopping & Retail",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "forever-21",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b9b71550-ea03-4590-af1e-42801d03a8a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "poi_name": "Bowlero Wichita",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "bowlero-wichita",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_698b2bd9f89cdd0105008b63",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_81173e3caf2b8e69ef4fd640",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_03ea75fc83771e81d638d1f8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_48674bd5c731f12c746b64ac",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_9410479a1263db67444de29f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_8655839012a91b41fab96dfe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_6e19bd1c-300e-4821-b3ec-d90c275d5c93",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "rating": "5.0",
      "name": "Missy Hogan",
      "text": "I have lived at Portofino apartments for one year.  The staff is absolutely amazing.  Jade is one of the kindest people I have ever met. She is very professional and at the same time feels like family.  The maintenance staff are very quick to respond. The apartment is spacious and lovely.  If you are looking for an apartment in a nice neighborhood and caring environment, this would be the place to move.",
      "date": "2025-08-25",
      "title": ""
    },
    {
      "id": "custom_bc9f351e-6fbc-4e93-8402-9b7b5a18ed52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "rating": "5.0",
      "name": "Dora Chavira",
      "text": "I’ve lived here for about a year with my partner. I can’t begin to brag about the staff!!!! Mikayla, Jade, and Ian are the most WONDERFUL people! They’re so attentive and are so quick to answer any question you have. They truly care about the community and do anything to make you feel as happy as possible! It’s been hard to find people that want their community to be safe and happy and they nail it every time. It’s not usually something you find in an apartment complex, and my partner and I are beyond grateful we made our move here! If you’re ever questioning your next move COME HERE!!! You’ll never regret it!",
      "date": "2025-08-25",
      "title": ""
    },
    {
      "id": "custom_f67b1417-c69a-45c2-9857-efad23af232c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "rating": "5.0",
      "name": "zachary.martinez27 mart1nez",
      "text": "I couldn’t be happier living at this apartment complex! The property is always well-kept, safe, and welcoming, but what really makes it stand out is the incredible staff. Jade, Ian, and Mikayla go above and beyond every single day. They are professional, friendly, and always quick to help with anything I need—whether it’s answering questions, handling maintenance requests, or just greeting me with a smile. Their positive attitude and genuine care make this place feel more like a community than just an apartment. Huge thanks to them for making this such a great place to live!",
      "date": "2025-08-20",
      "title": ""
    },
    {
      "id": "custom_6d8b0fb6-a0a8-46c8-bb87-f9dc5a8a0562",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "rating": "5.0",
      "name": "Mac and Dahl Schraad",
      "text": "We lived here for a year and Jade was the best! She was kind, responsive and a great problem solver. We had a wonderful Portofino experience and recommend to many others. The facility is great but the customer service is really what made it fantastic.",
      "date": "2025-07-02",
      "title": ""
    },
    {
      "id": "custom_770b9292-2a8c-4ce9-8c6a-0318433de32e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "rating": "5.0",
      "name": "Mandy Colón",
      "text": "My spouse and I moved into Portofino a couple of months ago after a Military move to here from Florida. We were apartment hunting long before our arrival and always had our sights set here. After touring different complexes, we choose Portofino for many reasons. The apartments are new and the location is ideal, quiet and not a far drive from anything. Staff & maintenance are excellent, quick and friendly. Thank you Ian and Jade for finding us a home on such short notice.",
      "date": "2025-06-11",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_a28dff1e-61b2-4971-9f87-9290b7d7be01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-9c6f-74eb-8f86-133dd7182cef.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of a resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb4f-9c6f-74eb-8f86-133dd7182cef",
        "storage_key": "property/6767906449166547/019cfb4f-9c6f-74eb-8f86-133dd7182cef.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Portofino Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=62ff5ddcd0ef131bb624386f"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a03b4-93c8-760f-8ed4-6d65032a5d49",
      "lead_source": "LANDING_PAGE",
      "name": "case-portofino-lp",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547"
    },
    {
      "lead_collector_id": "019cf79d-3e5c-76dc-85ca-81a65ea46be9",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "portofino",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-wichita",
      "search_query": "luxury apartments with pool Wichita KS",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Wichita",
      "h2_subtitle": "Discover luxury living at Portofino in Wichita, KS. Enjoy our sparkling swimming pool and other high-end amenities.",
      "page_copy": "Experience refined living at Portofino, where luxury apartments with a pool in Wichita, KS await you. Our one and two-bedroom residences boast large walk-in closets, cozy ceramic tile kitchens and baths, and select units even feature a fireplace for added comfort. Dive into our sparkling swimming pool to refresh and unwind after a long day. \n\nRelax in our exclusive grill and chill area with a fireplace or let your furry friend play in the welcoming bark park. Portofino Apartments offer more than just a place to live; they provide an exceptional lifestyle. Schedule a tour today and find your luxurious sanctuary in Wichita, KS.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
      "featured_image_media": {
        "alt_text": "Portofino Apartments logo",
        "public_id": "019cfb4e-b002-76af-b53d-18408c796305",
        "storage_key": "property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
        "width": 2550,
        "height": 860
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Wichita, KS",
      "seo_description": "Explore Portofino's luxury apartments with a pool in Wichita, KS. Enjoy premium amenities and a serene living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-sedgwick-county",
      "search_query": "dog friendly apartments in Sedgwick County",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in Sedgwick County",
      "h2_subtitle": "Portofino offers dog-friendly living in Sedgwick County. Enjoy a welcoming bark park among other amenities.",
      "page_copy": "At Portofino in Wichita, we cater to both you and your four-legged friends. Our dog-friendly apartments in Sedgwick County are designed with pet lovers in mind. With our dedicated bark park, your pets will have plenty of space to run and play. Beyond the pet-friendly environments, our community boasts upscale amenities such as large walk-in closets, package receiving, and a grill and chill area with fireplace. \n\nInside each home, you'll find ceramic tile in the kitchen and baths, and select units even feature a cozy fireplace. Our supportive community atmosphere makes it easy to feel at home. Explore the best in pet-friendly living by scheduling a tour at Portofino today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
      "featured_image_media": {
        "alt_text": "Portofino Apartments logo",
        "public_id": "019cfb4e-b002-76af-b53d-18408c796305",
        "storage_key": "property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
        "width": 2550,
        "height": 860
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments in Sedgwick County",
      "seo_description": "Discover dog-friendly apartments at Portofino in Sedgwick County, with amenities like a bark park and more.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "generator",
      "page_item_url": "apartments-with-fitness-center-wichita-67206",
      "search_query": "apartments with fitness center Wichita 67206",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Wichita",
      "h2_subtitle": "Find ideal living at Portofino in Wichita, 67206. Though not equipped with a fitness center, enjoy other luxurious amenities.",
      "page_copy": "While Portofino does not feature a traditional fitness center, our Wichita, 67206 residences offer an active lifestyle through other experiences. Dive into our sparkling swimming pool for a refreshing exercise routine or take your furry friend for a stroll in our welcoming bark park. Located conveniently in Wichita’s vibrant 67206 area, you’ll never be far from local parks and trails ideal for outdoor workouts.\n\nOur apartments in Wichita, KS enhance daily living with ceramic tile in kitchens and baths, large walk-in closets, and a grill and chill area with a fireplace. Select units feature a cozy indoor fireplace, perfect for relaxation after your activities. Discover the lifestyle you desire at Portofino, where luxury meets convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
      "featured_image_media": {
        "alt_text": "Portofino Apartments logo",
        "public_id": "019cfb4e-b002-76af-b53d-18408c796305",
        "storage_key": "property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
        "width": 2550,
        "height": 860
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments in Wichita 67206 with Great Amenities",
      "seo_description": "Portofino in Wichita, 67206 offers luxurious apartments with amenities like a pool and more, perfect for an active lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "generator",
      "page_item_url": "one-two-bedroom-apartments-fireplace-wichita",
      "search_query": "one and two bedroom apartments Wichita with fireplace",
      "category": "Amenity",
      "h1_title": "One & Two Bedroom Apartments with Fireplace",
      "h2_subtitle": "Portofino offers stylish one and two-bedroom apartments in Wichita with select units featuring a cozy fireplace.",
      "page_copy": "Discover spacious living at Portofino in Wichita, where our one and two-bedroom apartments provide a perfect blend of comfort and style. Selected units come with the cozy touch of a fireplace, offering a warm and inviting atmosphere during cooler months. Our homes are designed to enhance your lifestyle with features like large walk-in closets and ceramic tile in kitchens and baths.\n\nLocated in Wichita, Portofino brings luxury to your doorstep with additional community amenities such as a sparkling swimming pool and a delightful grill and chill area with a fireplace. Coupled with a package receiving service and a dedicated bark park, life here is both convenient and enjoyable. Schedule a tour today to explore your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
      "featured_image_media": {
        "alt_text": "Portofino Apartments logo",
        "public_id": "019cfb4e-b002-76af-b53d-18408c796305",
        "storage_key": "property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
        "width": 2550,
        "height": 860
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One & Two Bedroom Apartments in Wichita with Fireplace",
      "seo_description": "Explore Portofino's one and two-bedroom apartments in Wichita, featuring select units with a cozy fireplace and luxurious amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "generator",
      "page_item_url": "spacious-apartments-stainless-steel-kitchen-wichita",
      "search_query": "spacious apartments with stainless steel kitchen Wichita",
      "category": "Amenity",
      "h1_title": "Spacious Apartments in Wichita",
      "h2_subtitle": "Experience spacious apartments in Wichita at Portofino. Enjoy modern kitchen amenities and luxury living in our vibrant community.",
      "page_copy": "While Portofino does not feature stainless steel kitchens, our spacious apartments in Wichita offer a delightful living experience with other high-end amenities. Each one and two-bedroom apartment boasts carefully selected ceramic tile in kitchens and baths, providing a clean and modern touch. Enjoy the additional functionality of large walk-in closets and select units featuring cozy fireplaces, perfect for unwinding at home.\n\nPortofino's vibrant community amenities include a sparkling swimming pool, a grill and chill area with fireplace, and a package receiving service, ensuring a seamless lifestyle. Located in Wichita, our apartments provide easy access to local attractions and conveniences, complementing our well-designed living spaces. Discover the perfect blend of style and comfort today by scheduling a tour at Portofino.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
      "featured_image_media": {
        "alt_text": "Portofino Apartments logo",
        "public_id": "019cfb4e-b002-76af-b53d-18408c796305",
        "storage_key": "property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
        "width": 2550,
        "height": 860
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Apartments in Wichita - Portofino Living",
      "seo_description": "Explore Portofino's spacious apartments in Wichita with modern amenities like ceramic tiles and a fireplace, perfect for contemporary living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-wichita-ks-portofino",
      "search_query": "1 bedroom apartments in Wichita KS",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Wichita, KS",
      "h2_subtitle": "Discover cozy 1-bedroom apartments at Portofino, Wichita, KS, offering modern amenities and luxurious community features.",
      "page_copy": "At Portofino in Wichita, KS, our 1-bedroom apartments are designed to provide a comfortable and stylish living experience. These thoughtfully laid-out residences feature spacious interiors complete with ceramic tile in the kitchen and bath areas. Enjoy the convenience of large walk-in closets, perfect for organizing all your essentials.\n\nOur vibrant community amenities enhance your lifestyle with offerings such as a sparkling swimming pool and a relaxing grill and chill area with a fireplace. For pet enthusiasts, the on-site bark park is an ideal spot for furry friends to play. Explore the charm and convenience of living at Portofino in Wichita, KS, where comfort meets modern living. Schedule a visit and find your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
      "featured_image_media": {
        "alt_text": "Portofino Apartments logo",
        "public_id": "019cfb4e-b002-76af-b53d-18408c796305",
        "storage_key": "property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
        "width": 2550,
        "height": 860
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Wichita, KS - Portofino",
      "seo_description": "Discover 1-bedroom apartments at Portofino in Wichita, KS, featuring modern amenities and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-near-sedgwick-county",
      "search_query": "2 bedroom apartments near Sedgwick County",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near Sedgwick County",
      "h2_subtitle": "Explore spacious 2-bedroom apartments at Portofino, conveniently located near Sedgwick County, offering modern amenities and comfortable living.",
      "page_copy": "Nestled near the heart of Sedgwick County, Portofino offers elegant 2-bedroom apartments that redefine comfort and convenience. Each unit is meticulously designed with features like large walk-in closets and stylish ceramic tiles in both the kitchen and bath areas. Selected apartments even include a cozy fireplace, perfect for those chilly Wichita evenings.\n\nOur community's amenities enhance your living experience, with a sparkling swimming pool for relaxation and a grill and chill area complete with a fireplace for socializing. The on-site package receiving service and a pet-friendly bark park make daily life both convenient and enjoyable. Discover life at Portofino, where your ideal 2-bedroom home awaits in a premier Sedgwick County location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
      "featured_image_media": {
        "alt_text": "Portofino Apartments logo",
        "public_id": "019cfb4e-b002-76af-b53d-18408c796305",
        "storage_key": "property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
        "width": 2550,
        "height": 860
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near Sedgwick County - Portofino",
      "seo_description": "Explore Portofino's 2-bedroom apartments near Sedgwick County with modern features and luxurious amenities for comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "generator",
      "page_item_url": "apartments-near-wichita-state-university-ks",
      "search_query": "apartments near wichita state university ks",
      "category": "School",
      "h1_title": "Apartments Near Wichita State University",
      "h2_subtitle": "Discover convenience at Portofino, ideally located near Wichita State University, offering modern amenities and comfortable living spaces.",
      "page_copy": "Portofino presents the perfect opportunity for those seeking apartments near Wichita State University, KS. Our location combines accessibility and comfort, making it an ideal choice for students and faculty alike. Enjoy the convenience of spacious one and two-bedroom apartments, designed with ceramic tile in the kitchen and bath, ensuring a modern and functional living space.\n\nBeyond the apartment doors, residents benefit from luxury community amenities such as a refreshing swimming pool and a cozy grill and chill area with a fireplace. For pet owners, our bark park offers a delightful space for furry companions to frolic. Experience the charm of Portofino, just moments away from Wichita State University, and embrace a lifestyle of ease and modernity. Schedule a tour today and see what makes us a wonderful choice for university proximity living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
      "featured_image_media": {
        "alt_text": "Portofino Apartments logo",
        "public_id": "019cfb4e-b002-76af-b53d-18408c796305",
        "storage_key": "property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
        "width": 2550,
        "height": 860
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wichita State University - Portofino",
      "seo_description": "Portofino offers ideal apartments near Wichita State University, KS, with modern amenities and a convenient living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "generator",
      "page_item_url": "apartments-close-to-butler-community-college-andover",
      "search_query": "apartments close to butler community college andover",
      "category": "School",
      "h1_title": "Apartments Close to Butler Community College",
      "h2_subtitle": "Find your new home at Portofino, ideally situated close to Butler Community College in Andover, with modern amenities and a welcoming community.",
      "page_copy": "Portofino provides the perfect blend of convenience and comfort, offering apartments close to Butler Community College in Andover. Our community is an ideal choice for students seeking a peaceful and supportive environment, complete with spacious one and two-bedroom floor plans. Each apartment comes with large walk-in closets and ceramic tiles in the kitchen and bath, making organization and daily living a breeze.\n\nBeyond the comfort of your apartment, explore a variety of community features designed to enhance your living experience. Dive into our sparkling swimming pool or enjoy the company of friends in the communal grill and chill area with a fireplace. Pet lovers will appreciate the dedicated bark park, providing a great space for pets to play and socialize. Discover a welcoming home at Portofino, where collegiate and modern living come together seamlessly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
      "featured_image_media": {
        "alt_text": "Portofino Apartments logo",
        "public_id": "019cfb4e-b002-76af-b53d-18408c796305",
        "storage_key": "property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
        "width": 2550,
        "height": 860
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Butler Community College - Portofino",
      "seo_description": "Portofino offers modern apartments near Butler Community College in Andover, featuring spacious amenities and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "generator",
      "page_item_url": "sedgwick-county-apts-near-woolsey-hall",
      "search_query": "sedgwick county apts near woolsey hall",
      "category": "School",
      "h1_title": "Sedgwick County Apts Near Woolsey Hall",
      "h2_subtitle": "Experience refined living at Portofino, located near Woolsey Hall in Sedgwick County, featuring luxurious amenities and spacious living spaces.",
      "page_copy": "For those seeking Sedgwick County apts near Woolsey Hall, Portofino stands out as a premier choice offering both comfort and convenience. Located within easy reach of this iconic hall, our community provides exceptional living options with well-designed one and two-bedroom apartments. Enjoy features like large walk-in closets and ceramic tiled kitchens and bathrooms, which complement the modern aesthetic of each unit.\n\nPortofino also boasts a collection of community amenities aimed at enhancing your everyday life. Residents can unwind at the shimmering swimming pool or host gatherings in the grill and chill area complete with a cozy fireplace. For pet owners, the bark park offers a dedicated space for pets to play. Discover the perfect blend of location and luxury at Portofino, where proximity to Woolsey Hall opens up a world of opportunities just around the corner.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
      "featured_image_media": {
        "alt_text": "Portofino Apartments logo",
        "public_id": "019cfb4e-b002-76af-b53d-18408c796305",
        "storage_key": "property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
        "width": 2550,
        "height": 860
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sedgwick County Apts Near Woolsey Hall - Portofino",
      "seo_description": "Discover Portofino's apts near Woolsey Hall, Sedgwick County, offering luxurious amenities and spacious living options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "generator",
      "page_item_url": "apartments-near-wesley-medical-center-wichita",
      "search_query": "apartments near Wesley Medical Center Wichita",
      "category": "Hospital",
      "h1_title": "Apartments Near Wesley Medical Center",
      "h2_subtitle": "Discover the ideal living space at Portofino, just minutes from Wesley Medical Center in Wichita, featuring upscale amenities and comfort.",
      "page_copy": "For those in need of apartments near Wesley Medical Center, Wichita, Portofino offers a blend of convenience, comfort, and community. Situated within a short distance from this key medical hub, our property provides the perfect location for healthcare professionals and patients alike. Choose from our thoughtfully designed one and two-bedroom apartments, featuring modern ceramic tile in kitchens and baths and large walk-in closets for ample storage.\n\nBeyond individual units, Portofino enhances the living experience with a range of community amenities. Relax by the sparkling swimming pool or enjoy social time in the grill and chill area with a fireplace. Pet owners will appreciate the on-site bark park, perfect for playful pets. Experience a seamless blend of modern living and proximity to Wesley Medical Center, where convenience meets comfort at Portofino.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
      "featured_image_media": {
        "alt_text": "Portofino Apartments logo",
        "public_id": "019cfb4e-b002-76af-b53d-18408c796305",
        "storage_key": "property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
        "width": 2550,
        "height": 860
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wesley Medical Center - Portofino",
      "seo_description": "Find your home at Portofino, near Wesley Medical Center in Wichita. Enjoy modern amenities in spacious apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "generator",
      "page_item_url": "apartments-close-to-ascension-via-christi-st-joseph-sedgwick-county",
      "search_query": "apartments close to Ascension Via Christi St. Joseph Sedgwick County",
      "category": "Hospital",
      "h1_title": "Apts Close to Ascension Via Christi St. Joseph",
      "h2_subtitle": "Live comfortably at Portofino, located near Ascension Via Christi St. Joseph in Sedgwick County, featuring luxurious and practical features.",
      "page_copy": "Portofino presents an exceptional living experience for those seeking apartments close to Ascension Via Christi St. Joseph in Sedgwick County. Our community offers a perfect location for healthcare professionals and visitors, combining convenience with comfort in our one and two-bedroom apartments. Enjoy the spaciousness of large walk-in closets and the elegance of ceramic tiling in kitchens and baths.\n\nAt Portofino, community life flourishes with amenities designed to enrich your lifestyle. Dive into relaxation at our sparkling swimming pool or gather with friends at the grill and chill area, equipped with a cozy fireplace. For pet lovers, the bark park serves as a delightful retreat for pets. Embrace a harmonious blend of proximity and modern living at Portofino, where everyday life is enhanced by thoughtful design and location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
      "featured_image_media": {
        "alt_text": "Portofino Apartments logo",
        "public_id": "019cfb4e-b002-76af-b53d-18408c796305",
        "storage_key": "property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
        "width": 2550,
        "height": 860
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Ascension Via Christi St. Joseph - Portofino",
      "seo_description": "Experience comfort at Portofino near Ascension Via Christi St. Joseph, Sedgwick County. Enjoy modern amenities and spacious living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "generator",
      "page_item_url": "apartments-near-great-plains-nature-center-wichita",
      "search_query": "apartments near Great Plains Nature Center Wichita",
      "category": "Park",
      "h1_title": "Apts Near Great Plains Nature Center",
      "h2_subtitle": "Embrace nature and modern comforts at Portofino in Wichita, located close to the Great Plains Nature Center with luxurious amenities.",
      "page_copy": "For those seeking a blend of natural beauty and upscale living, Portofino offers perfect apartments near the Great Plains Nature Center in Wichita. Our prime location not only places you near one of the city’s green treasures but also envelopes you in modern comforts with our meticulously designed one and two-bedroom units, boasting amenities like large walk-in closets and ceramic tile flooring.\n\nExperience an enriching community lifestyle with a range of quality amenities. Enjoy sun-soaked days at our shimmering swimming pool or entertain guests in the grill and chill area complete with a fireplace. Pet owners will appreciate our dedicated bark park, a highlight of our pet-friendly policy. Discover the harmony of nature and contemporary living at Portofino, where proximity to the Great Plains Nature Center enhances your lifestyle every day.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
      "featured_image_media": {
        "alt_text": "Portofino Apartments logo",
        "public_id": "019cfb4e-b002-76af-b53d-18408c796305",
        "storage_key": "property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
        "width": 2550,
        "height": 860
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Great Plains Nature Center - Portofino",
      "seo_description": "Live near Great Plains Nature Center at Portofino, Wichita. Enjoy luxurious amenities and spacious apartments close to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "generator",
      "page_item_url": "apartments-close-to-edgemoor-park-sedgwick-county",
      "search_query": "apartments close to Edgemoor Park Sedgwick County",
      "category": "Park",
      "h1_title": "Apts Close to Edgemoor Park",
      "h2_subtitle": "Find your home at Portofino, near Edgemoor Park in Sedgwick County, where modern living meets lush park surroundings.",
      "page_copy": "For those searching for apartments close to Edgemoor Park in Sedgwick County, Portofino offers an ideal location that combines access to beautiful green spaces with luxurious living. Our one and two-bedroom apartments are designed to provide comfort and style, featuring desirable amenities such as large walk-in closets and ceramic tile in the kitchens and baths.\n\nEnhance your lifestyle with our top-tier community features. Whether you're lounging by the sparkling swimming pool or socializing in the grill and chill area, complete with a welcoming fireplace, you'll find the perfect balance of leisure and community interaction. Pet owners will enjoy our bark park designed for furry friends. At Portofino, you can embrace a lifestyle of modern elegance while staying close to the natural beauty of Edgemoor Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
      "featured_image_media": {
        "alt_text": "Portofino Apartments logo",
        "public_id": "019cfb4e-b002-76af-b53d-18408c796305",
        "storage_key": "property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
        "width": 2550,
        "height": 860
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Edgemoor Park - Portofino",
      "seo_description": "Discover Portofino, near Edgemoor Park in Sedgwick County. Enjoy modern amenities and serene park surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "generator",
      "page_item_url": "fairmount-park-nearby-apartments-67206",
      "search_query": "Fairmount Park nearby apartments 67206",
      "category": "Park",
      "h1_title": "Apts Near Fairmount Park, 67206",
      "h2_subtitle": "Explore Portofino's stylish apartments near Fairmount Park, 67206, offering a serene and luxurious living environment.",
      "page_copy": "Discover the ideal balance of tranquility and modern living at Portofino, featuring nearby apartments to Fairmount Park within the 67206 area. Our sophisticated one and two-bedroom apartments offer a peaceful retreat with large walk-in closets and stylish ceramic tile in kitchens and baths, ideal for comfortable living.\n\nPortofino shines as a community that values leisure and lifestyle. Dive into relaxation at our sparkling swimming pool, or enjoy quality time in the grill and chill area, complete with a cozy fireplace. Our bark park welcomes your furry residents to enjoy some playtime. With the beautiful Fairmount Park just a stone's throw away, Portofino residents can enjoy both the outdoors and luxurious apartment amenities in a sought-after location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
      "featured_image_media": {
        "alt_text": "Portofino Apartments logo",
        "public_id": "019cfb4e-b002-76af-b53d-18408c796305",
        "storage_key": "property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
        "width": 2550,
        "height": 860
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Fairmount Park, 67206 - Portofino",
      "seo_description": "Live at Portofino near Fairmount Park, 67206. Enjoy stylishly designed apartments and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166547",
      "source": "generator",
      "page_item_url": "lw-clapp-park-neighborhood-apartments-ks",
      "search_query": "L.W. Clapp Park neighborhood apartments KS",
      "category": "Park",
      "h1_title": "Apts in L.W. Clapp Park Area",
      "h2_subtitle": "Experience refined living at Portofino near L.W. Clapp Park neighborhood, KS, where comfort meets convenience.",
      "page_copy": "Nestled close to the charming L.W. Clapp Park neighborhood in KS, Portofino offers a living experience that blends serene park views with luxurious apartment amenities. Our beautifully appointed one and two-bedroom apartments provide residents with spacious living areas, highlighted by large walk-in closets and elegant ceramic tile finishes in both kitchen and baths.\n\nPortofino is more than just a place to live; it's a lifestyle choice. Residents can unwind at our sparkling swimming pool, relax in the inviting grill and chill area with a fireplace, or let their pets roam freely in the dedicated bark park. Discover the vibrant lifestyle and unparalleled convenience offered by Portofino, ideally situated near the picturesque L.W. Clapp Park neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
      "featured_image_media": {
        "alt_text": "Portofino Apartments logo",
        "public_id": "019cfb4e-b002-76af-b53d-18408c796305",
        "storage_key": "property/6767906449166547/019cfb4e-b002-76af-b53d-18408c796305.webp",
        "width": 2550,
        "height": 860
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts in L.W. Clapp Park Area - Portofino",
      "seo_description": "Find luxurious living at Portofino, near the L.W. Clapp Park neighborhood in KS. Enjoy modern amenities and serene surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5201"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-D028XM4VXT"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18128852163"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/portofino/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T8WZT7P3"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449166547/019d1bd6-5ddb-765e-823d-896fa1fe1f22.pdf"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "15147453852"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "a72e42a3-a2e9-43f7-bca4-a68bc9786616"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "866-217-9054"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6500828ad1316c637dd44ed5"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkVZTnJ6Z0VJVVgydkdNclVZWVFuZ1E9PSIsInZhbHVlIjoiNllIRlJCelNCRzlIMFI3Si9HRE5mZz09IiwibWFjIjoiN2QzYzA4YjUyNDZlYmQzOGYzMjY2ZmYwOTcyMTBiNTVjMzQzNTk5NTBlZjIwMTU0MDdmM2EwM2QxZDMyOGJmMiJ9"
    }
  ],
  "custom_qb_id": "5201",
  "custom_ga4_id": "G-D028XM4VXT",
  "custom_repli_id": "18128852163",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/portofino/register/",
  "custom_google_gtm_id": "GTM-T8WZT7P3",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449166547/019d1bd6-5ddb-765e-823d-896fa1fe1f22.pdf",
  "custom_hubspot_company_id": "15147453852",
  "custom_rentgrata_property_id": "a72e42a3-a2e9-43f7-bca4-a68bc9786616",
  "custom_ppc_tracking_phone_number": "866-217-9054",
  "custom_residentboost_apartment_id": "6500828ad1316c637dd44ed5",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkVZTnJ6Z0VJVVgydkdNclVZWVFuZ1E9PSIsInZhbHVlIjoiNllIRlJCelNCRzlIMFI3Si9HRE5mZz09IiwibWFjIjoiN2QzYzA4YjUyNDZlYmQzOGYzMjY2ZmYwOTcyMTBiNTVjMzQzNTk5NTBlZjIwMTU0MDdmM2EwM2QxZDMyOGJmMiJ9"
};

export const generatedAt = '2026-08-27T21:34:05.903Z';
